import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Announcement = {
  __typename?: 'Announcement';
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum AnyOrAllType {
  All = 'ALL',
  Any = 'ANY'
}

export type ApproveBookingPortalRegistrationRequestResult = {
  __typename?: 'ApproveBookingPortalRegistrationRequestResult';
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<BookingPortalRegistrationRequestError>;
  success: Scalars['Boolean']['output'];
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export type Booking = {
  __typename?: 'Booking';
  bookingSourceId?: Maybe<Scalars['String']['output']>;
  chatRoom?: Maybe<ChatRoom>;
  coupon?: Maybe<Coupon>;
  couponCode?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<BookingDetail>>;
  didAttend?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  group: Group;
  guests: Array<Guest>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  leadGuest?: Maybe<Guest>;
  numConfirmedBookings: Scalars['Int']['output'];
  numPeople?: Maybe<Scalars['Int']['output']>;
  /**
   * Seats held by live invitations that name no traveler, so callers can
   * tell whether the booking still has room without seeing who was invited.
   */
  openInvitationCount: Scalars['Int']['output'];
  paidAmount?: Maybe<PaidAmount>;
  paymentAmount: Scalars['Float']['output'];
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickupLocation?: Maybe<PickupLocation>;
  recommendedProducts?: Maybe<Array<Product>>;
  repeaterCoupon?: Maybe<Coupon>;
  reviewRating?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<BookingSource>;
  state: Scalars['String']['output'];
  whenFourOrFiveStarsClicked?: Maybe<Scalars['DateTime']['output']>;
  whereReviewed?: Maybe<Scalars['String']['output']>;
};


export type BookingPaymentAmountArgs = {
  currency?: InputMaybe<Currency>;
};

export type BookingDetail = {
  __typename?: 'BookingDetail';
  productPrice: ProductPrice;
  quantity: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};


export type BookingDetailUnitAmountArgs = {
  currency: Currency;
};

export enum BookingPortalLoginRequestedFrom {
  ExpiredLink = 'expired_link',
  MyTripsPage = 'my_trips_page',
  TravelerPicker = 'traveler_picker'
}

export enum BookingPortalLoginTokenState {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Used = 'USED',
  Valid = 'VALID'
}

export type BookingPortalLoginTokenStatus = {
  __typename?: 'BookingPortalLoginTokenStatus';
  /** Null for a token that opens every trip under the traveler's email. */
  bookingId?: Maybe<Scalars['ID']['output']>;
  guestGivenName?: Maybe<Scalars['String']['output']>;
  guestId?: Maybe<Scalars['ID']['output']>;
  guestMaskedEmail?: Maybe<Scalars['String']['output']>;
  state: BookingPortalLoginTokenState;
  tourDate?: Maybe<Scalars['Date']['output']>;
  tourName?: Maybe<Scalars['String']['output']>;
  tourPoster?: Maybe<Scalars['String']['output']>;
};

export type BookingPortalPendingInvitation = {
  __typename?: 'BookingPortalPendingInvitation';
  bookingId: Scalars['ID']['output'];
  created: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /**
   * Set when the invitation was raised for a co-traveler named at checkout,
   * so the seat it belongs to is known before anyone accepts it.
   */
  guestId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type BookingPortalRegistrationRequest = {
  __typename?: 'BookingPortalRegistrationRequest';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  booking: Booking;
  bookingId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  guest?: Maybe<Guest>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  token: Scalars['ID']['output'];
};

export enum BookingPortalRegistrationRequestError {
  AlreadyHandled = 'ALREADY_HANDLED',
  AlreadyRegistered = 'ALREADY_REGISTERED',
  InvalidToken = 'INVALID_TOKEN',
  Other = 'OTHER'
}

export enum BookingPortalTab {
  Chat = 'chat',
  Group = 'group',
  Guide = 'guide',
  Photos = 'photos',
  Review = 'review',
  Trip = 'trip'
}

export type BookingSource = {
  __typename?: 'BookingSource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BulkBooking = {
  __typename?: 'BulkBooking';
  bookings: Array<Booking>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  paidAmount?: Maybe<PaidAmount>;
};

export type CancelBookingInput = {
  bookingId: Scalars['ID']['input'];
  cancellationReason: Scalars['String']['input'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  backofficeUserId?: Maybe<Scalars['ID']['output']>;
  body: Scalars['String']['output'];
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  chatRoomId: Scalars['ID']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  events?: Maybe<Array<ChatMessageEvent>>;
  guide?: Maybe<Guide>;
  guideId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<ChatMessageMedia>>;
};

export type ChatMessageEvent = {
  __typename?: 'ChatMessageEvent';
  bookingId?: Maybe<Scalars['ID']['output']>;
  created: Scalars['DateTime']['output'];
  groupId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ChatMessageMedia = {
  __typename?: 'ChatMessageMedia';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ChatMessagesResponse = {
  __typename?: 'ChatMessagesResponse';
  hasMore: Scalars['Boolean']['output'];
  messages: Array<ChatMessage>;
  totalCount: Scalars['Int']['output'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  guide?: Maybe<Guide>;
  guideId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export enum ChatRoomType {
  Booking = 'BOOKING',
  Guide = 'GUIDE'
}

export type CloudinaryFile = {
  __typename?: 'CloudinaryFile';
  folder: Scalars['String']['output'];
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  documentUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  amount: Scalars['Float']['output'];
  availableFrom: Scalars['DateTime']['output'];
  availableUntil?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  currency?: Maybe<Currency>;
  type: CouponType;
};


export type CouponAmountArgs = {
  currency?: InputMaybe<Currency>;
};

export enum CouponType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type CreateBookingInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  email: Scalars['String']['input'];
  guests: Array<GuestInput>;
  guideId?: InputMaybe<Scalars['ID']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  optInMailingList: Scalars['Boolean']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  priceTypes: Array<PriceTypeInput>;
  productId: Scalars['ID']['input'];
  specialRequests?: InputMaybe<Scalars['String']['input']>;
  time: Scalars['Time']['input'];
};

export type CreateBulkBookingInput = {
  bookings: Array<CreateBookingInput>;
};

export type CreateStripePaymentInput = {
  bookingId: Scalars['ID']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStripePaymentResponse = {
  __typename?: 'CreateStripePaymentResponse';
  clientSecret: Scalars['String']['output'];
};

export enum Currency {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Myr = 'MYR',
  Nzd = 'NZD',
  Php = 'PHP',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Twd = 'TWD',
  Usd = 'USD'
}

export type CustomGroupItinerary = {
  __typename?: 'CustomGroupItinerary';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  stepDescription: Scalars['String']['output'];
  stepOrder: Scalars['Int']['output'];
};

export type DietaryRestriction = {
  __typename?: 'DietaryRestriction';
  diet: Scalars['String']['output'];
  isPossible: YesNoLimited;
  memo?: Maybe<Scalars['String']['output']>;
};

export type EditWaitingListInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addToPromotionalMails?: InputMaybe<Scalars['Boolean']['input']>;
  contacted?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  groupSize: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  untilDate: Scalars['Date']['input'];
};

export type EditWaitingListResponse = {
  __typename?: 'EditWaitingListResponse';
  overlappingWaitingLists?: Maybe<Array<WaitingList>>;
  waitingList: WaitingList;
};

export type EditWaitingListUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  waitingLists?: InputMaybe<Array<EditWaitingListInput>>;
};

export type Faq = {
  __typename?: 'Faq';
  context?: Maybe<FaqCategoryContext>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  questionsAndAnswers?: Maybe<Array<Maybe<QuestionAndAnswer>>>;
};

export enum FaqCategoryContext {
  CustomTours = 'CUSTOM_TOURS'
}

export type FaqsInput = {
  context?: InputMaybe<FaqCategoryContext>;
  faqId?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Platform>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FaqsResult = {
  __typename?: 'FaqsResult';
  records: Array<Faq>;
  totalCategories: Scalars['Int']['output'];
};

export type FeaturedBanner = {
  __typename?: 'FeaturedBanner';
  created: Scalars['DateTime']['output'];
  ctaText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  pageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FixedPrice = {
  __typename?: 'FixedPrice';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export type GeoLocation = {
  __typename?: 'GeoLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GeoLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GoogleMapsQuery = {
  __typename?: 'GoogleMapsQuery';
  created: Scalars['DateTime']['output'];
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsQueryInput = {
  geoLocation?: InputMaybe<GeoLocationInput>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  customGroupItinerary?: Maybe<Array<CustomGroupItinerary>>;
  date: Scalars['Date']['output'];
  faces: Array<Scalars['String']['output']>;
  guideAssignments: Array<GuideAssignment>;
  guides: Array<Guide>;
  /**
   * True once the tour's start time plus its duration has passed, in the
   * tour's timezone. Reviews open from that moment.
   */
  hasEnded: Scalars['Boolean']['output'];
  hasMedia: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  mainGuide?: Maybe<Guide>;
  maxPeople: Scalars['Int']['output'];
  media: Array<GroupMedia>;
  product: Product;
  time: Scalars['Time']['output'];
};

export type GroupMedia = {
  __typename?: 'GroupMedia';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  booking: Booking;
  bookingId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  isLeadGuest: Scalars['Boolean']['output'];
  /**
   * Obfuscated form of the guest's email (e.g. "m•••@gmail.com"), safe to show
   * on the unauthenticated portal login page so a traveler can recognise their
   * own row. Null when the guest has no email and therefore cannot be sent a
   * login link.
   */
  maskedEmail?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  review?: Maybe<GuestReview>;
};

export type GuestInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type GuestReview = {
  __typename?: 'GuestReview';
  guestId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reviewSource: Scalars['String']['output'];
  reviewSourceUrl?: Maybe<Scalars['String']['output']>;
  reviewText?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
};

export type GuestReviewInput = {
  guestId: Scalars['ID']['input'];
  reviewText?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};

export type Guide = {
  __typename?: 'Guide';
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Language>>;
  media?: Maybe<Array<GuideMedia>>;
  metrics?: Maybe<GuideMetrics>;
  nickName: Scalars['String']['output'];
  products?: Maybe<Array<GuideProduct>>;
  profilePic?: Maybe<Scalars['String']['output']>;
  profileVideo?: Maybe<Scalars['String']['output']>;
  reviewSummary?: Maybe<GuideReviewSummary>;
  reviews?: Maybe<ReviewsResult>;
  translation?: Maybe<GuideTranslation>;
};


export type GuideReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GuideTranslationArgs = {
  lang: Iso639;
};

export type GuideApplicationDocumentInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type GuideApplicationInput = {
  age: Scalars['Int']['input'];
  countryCode: Scalars['String']['input'];
  daysAvailablePerMonth: Scalars['String']['input'];
  documentFiles?: InputMaybe<Array<GuideApplicationDocumentInput>>;
  email: Scalars['String']['input'];
  englishLevel: LanguageLevel;
  fullName: Scalars['String']['input'];
  gender: Gender;
  howDidYouHearAboutMt: Scalars['String']['input'];
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  japaneseLevel: LanguageLevel;
  locationId: Scalars['String']['input'];
  preferredTours?: InputMaybe<Array<Scalars['String']['input']>>;
  questionPresentationVideoUrl?: InputMaybe<Scalars['String']['input']>;
  residenceCardExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  residenceStatus?: InputMaybe<Scalars['String']['input']>;
  workAuthCategory?: InputMaybe<Scalars['String']['input']>;
  workRestriction?: InputMaybe<Scalars['String']['input']>;
};

export type GuideAssignment = {
  __typename?: 'GuideAssignment';
  guide: Guide;
  lastKnownLocation?: Maybe<LastKnownLocation>;
  role: Scalars['String']['output'];
};

export type GuideMedia = {
  __typename?: 'GuideMedia';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GuideMetrics = {
  __typename?: 'GuideMetrics';
  numPeople: Scalars['Int']['output'];
  numTours: Scalars['Int']['output'];
};

export type GuideProduct = {
  __typename?: 'GuideProduct';
  firstAvailableDateTime?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
};

export type GuideReviewSummary = {
  __typename?: 'GuideReviewSummary';
  average?: Maybe<Scalars['Float']['output']>;
  guideId: Scalars['ID']['output'];
  numReviews: Scalars['Int']['output'];
};

export type GuideTranslation = {
  __typename?: 'GuideTranslation';
  description?: Maybe<Scalars['String']['output']>;
  hobbies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  language: Iso639;
};

export type GuidesInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderField?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type HtmlContent = {
  __typename?: 'HTMLContent';
  html: Scalars['String']['output'];
};

export type Influencer = {
  __typename?: 'Influencer';
  guide?: Maybe<Guide>;
  iconSrc: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tiktokUrl?: Maybe<Scalars['String']['output']>;
  xUrl?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type Inquiry = {
  __typename?: 'Inquiry';
  bookingId?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  companyUrl?: Maybe<Scalars['String']['output']>;
  countryOfResidence?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isConnectedToBokun?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfGuests?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  requestedTourDate?: Maybe<Scalars['Date']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  typeOfPartnership?: Maybe<Scalars['String']['output']>;
  typeOfPromotion?: Maybe<Scalars['String']['output']>;
};

export type InterviewArticle = {
  __typename?: 'InterviewArticle';
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  productLinks?: Maybe<Array<Maybe<InterviewArticleProduct>>>;
  products: Array<Product>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InterviewArticleProduct = {
  __typename?: 'InterviewArticleProduct';
  interviewArticleId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
};

export type InterviewArticlesResponse = {
  __typename?: 'InterviewArticlesResponse';
  records: Array<InterviewArticle>;
  totalRecords: Scalars['Int']['output'];
};

export enum Iso639 {
  En = 'en',
  Jp = 'jp',
  Ko = 'ko',
  Th = 'th',
  Zh = 'zh',
  ZhTw = 'zh_tw'
}

export type Language = {
  __typename?: 'Language';
  iso639_1: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LanguageLevel {
  Conversational = 'conversational',
  Fluent = 'fluent',
  Intermediate = 'intermediate'
}

export type LastKnownLocation = {
  __typename?: 'LastKnownLocation';
  accuracy?: Maybe<Scalars['Float']['output']>;
  dateTime: Scalars['DateTime']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type Location = {
  __typename?: 'Location';
  ancestor?: Maybe<Location>;
  ancestors: Array<Location>;
  children: Array<Location>;
  country?: Maybe<Location>;
  countryId?: Maybe<Scalars['ID']['output']>;
  descendants: Array<Location>;
  destinationNames?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Array<LocationFaq>>;
  guideRecruitmentOpen?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  locationType: LocationType;
  name: Scalars['String']['output'];
  navImageUrl?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Location>;
  parentId?: Maybe<Scalars['ID']['output']>;
  products: Array<Product>;
  slug: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  translation: LocationTranslation;
  translations: Array<LocationTranslation>;
  videoApplicationRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type LocationAncestorArgs = {
  ancestorType: LocationType;
};


export type LocationAncestorsArgs = {
  ancestorType?: InputMaybe<LocationType>;
};


export type LocationDescendantsArgs = {
  descendantType?: InputMaybe<LocationType>;
};


export type LocationFaqsArgs = {
  lang?: InputMaybe<Iso639>;
};


export type LocationTranslationArgs = {
  lang: Iso639;
};

export type LocationCenter = {
  __typename?: 'LocationCenter';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LocationFaq = {
  __typename?: 'LocationFAQ';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  locationId: Scalars['ID']['output'];
  translations?: Maybe<Array<LocationFaqTranslation>>;
};

export type LocationFaqTranslation = {
  __typename?: 'LocationFAQTranslation';
  answer: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lang: Iso639;
  locationFaqId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type LocationPickupZone = {
  __typename?: 'LocationPickupZone';
  center: LocationCenter;
  radius: Scalars['Float']['output'];
};

export type LocationTranslation = {
  __typename?: 'LocationTranslation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lang: Iso639;
  locationId: Scalars['ID']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum LocationType {
  City = 'CITY',
  Country = 'COUNTRY',
  Prefecture = 'PREFECTURE',
  Province = 'PROVINCE',
  Region = 'REGION',
  State = 'STATE'
}

export type LocationsInput = {
  hasProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isRecruiting?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationTypes?: InputMaybe<Array<LocationType>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderInput>;
};

export type LocationsResponse = {
  __typename?: 'LocationsResponse';
  records: Array<Location>;
  totalRecords: Scalars['Int']['output'];
};

export type MediaCategory = {
  __typename?: 'MediaCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum MediaType {
  Image = 'image',
  Video = 'video'
}

export type MultidayItinerariesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MultidayItinerariesResponse = {
  __typename?: 'MultidayItinerariesResponse';
  records: Array<MultidayItinerary>;
  totalRecords: Scalars['Int']['output'];
};

export type MultidayItinerary = {
  __typename?: 'MultidayItinerary';
  bannerDescription?: Maybe<Scalars['String']['output']>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  days?: Maybe<Array<MultidayItineraryDay>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageThumbnail?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastPublished?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['String']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
};

export type MultidayItineraryBlock = {
  __typename?: 'MultidayItineraryBlock';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  stepOrder: Scalars['Int']['output'];
  time?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MultidayItineraryDay = {
  __typename?: 'MultidayItineraryDay';
  blocks?: Maybe<Array<MultidayItineraryBlock>>;
  dayNumber: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  approveBookingPortalRegistrationRequest?: Maybe<ApproveBookingPortalRegistrationRequestResult>;
  cancelBooking: Scalars['Boolean']['output'];
  confirmPaypalPayment: Booking;
  createBooking: Booking;
  createBulkBooking: BulkBooking;
  createRepeaterCoupon?: Maybe<Scalars['Boolean']['output']>;
  createStripePayment: CreateStripePaymentResponse;
  deleteAllWaitingLists: Array<WaitingList>;
  deleteWaitingListUser: WaitingListUser;
  deleteWaitingLists: Array<WaitingList>;
  devSkipPayment: Scalars['Boolean']['output'];
  editGuestReview?: Maybe<GuestReview>;
  editWaitingList: Array<WaitingList>;
  editWaitingListUser: WaitingListUser;
  endStorefrontSession: Scalars['Boolean']['output'];
  generateStripePaymentLink: Scalars['String']['output'];
  loginBookingPortal: StorefrontSessionTokens;
  registerBookingPortalGuest: StorefrontSessionTokens;
  removeBookingPortalGuest: Scalars['Boolean']['output'];
  requestEbook: Scalars['Boolean']['output'];
  rescheduleBooking: Scalars['Boolean']['output'];
  resendBookingPortalPendingInvitation: Scalars['Boolean']['output'];
  resendConfirmationEmails: Scalars['Boolean']['output'];
  revokeBookingPortalPendingInvitation: Scalars['Boolean']['output'];
  revokeCheckoutBookingPortalInvitation: Scalars['Boolean']['output'];
  saveGuideApplication: Scalars['Boolean']['output'];
  sendBookingPortalInvitation: BookingPortalPendingInvitation;
  /**
   * Emails a fresh single-use login link: to the guest's booking when called
   * with guestId, to every trip under the traveler's email when called with
   * guestEmail or with allTrips. For a link to one booking, tab and rating
   * send the traveler back to where the old link pointed. Sends nothing while
   * an unused link went out less than five minutes ago. requestedFrom is
   * stored for dashboarding and reporting.
   */
  sendBookingPortalLoginToken: Scalars['Boolean']['output'];
  sendBookingPortalRegistrationRequest: Scalars['Boolean']['output'];
  sendChatMessage: ChatMessage;
  /**
   * Invitation writes for the checkout confirmation page. Authorized by the
   * booking's payment being fresh rather than by a portal session, so they add
   * and revoke invitations only — they never expose guest details.
   */
  sendCheckoutBookingPortalInvitation: BookingPortalPendingInvitation;
  sendInquiry: Inquiry;
  setReviewLocation: ReviewLocationSelection;
  setWaitingListActive: Scalars['Boolean']['output'];
  signContracts?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Signs the buyer into their portal straight from checkout confirmation.
   * Authorized by a fresh payment rather than a session, and booking-scoped.
   */
  startCheckoutBookingPortalSession: StorefrontSessionTokens;
  toggleWaitingList: Scalars['Boolean']['output'];
  updateBookingPortalPendingInvitation: Scalars['Boolean']['output'];
  updateCurrentBookingPortalGuest: Scalars['Boolean']['output'];
  updatePickupLocation: Scalars['Boolean']['output'];
  updateStripeCharge: Scalars['Boolean']['output'];
  uploadImage: CloudinaryFile;
};


export type MutationApproveBookingPortalRegistrationRequestArgs = {
  token: Scalars['ID']['input'];
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationConfirmPaypalPaymentArgs = {
  country: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateBulkBookingArgs = {
  input: CreateBulkBookingInput;
};


export type MutationCreateRepeaterCouponArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationCreateStripePaymentArgs = {
  input: CreateStripePaymentInput;
};


export type MutationDeleteAllWaitingListsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaitingListUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaitingListsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDevSkipPaymentArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationEditGuestReviewArgs = {
  input: GuestReviewInput;
};


export type MutationEditWaitingListArgs = {
  input: EditWaitingListInput;
};


export type MutationEditWaitingListUserArgs = {
  input: EditWaitingListUserInput;
};


export type MutationGenerateStripePaymentLinkArgs = {
  bookingId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationLoginBookingPortalArgs = {
  token: Scalars['ID']['input'];
};


export type MutationRegisterBookingPortalGuestArgs = {
  guest: RegisterNewGuestInput;
  token: Scalars['ID']['input'];
};


export type MutationRemoveBookingPortalGuestArgs = {
  guestId: Scalars['ID']['input'];
};


export type MutationRequestEbookArgs = {
  input: RequestEbookInput;
};


export type MutationRescheduleBookingArgs = {
  input: RescheduleBookingInput;
};


export type MutationResendBookingPortalPendingInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationResendConfirmationEmailsArgs = {
  email: Scalars['String']['input'];
};


export type MutationRevokeBookingPortalPendingInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationRevokeCheckoutBookingPortalInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationSaveGuideApplicationArgs = {
  input: GuideApplicationInput;
};


export type MutationSendBookingPortalInvitationArgs = {
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  guestId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendBookingPortalLoginTokenArgs = {
  allTrips?: InputMaybe<Scalars['Boolean']['input']>;
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  guestId?: InputMaybe<Scalars['ID']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  requestedFrom: BookingPortalLoginRequestedFrom;
  tab?: InputMaybe<BookingPortalTab>;
};


export type MutationSendBookingPortalRegistrationRequestArgs = {
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendCheckoutBookingPortalInvitationArgs = {
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  guestId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendInquiryArgs = {
  input: SendInquiryInput;
};


export type MutationSetReviewLocationArgs = {
  input: SetReviewLocationInput;
};


export type MutationSetWaitingListActiveArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSignContractsArgs = {
  guideId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};


export type MutationStartCheckoutBookingPortalSessionArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationToggleWaitingListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingPortalPendingInvitationArgs = {
  input: UpdateBookingPortalPendingInvitationInput;
};


export type MutationUpdateCurrentBookingPortalGuestArgs = {
  input: UpdateCurrentBookingPortalGuestInput;
};


export type MutationUpdatePickupLocationArgs = {
  input: UpdatePickupLocationInput;
};


export type MutationUpdateStripeChargeArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationUploadImageArgs = {
  file: Scalars['Upload']['input'];
  folder: Scalars['String']['input'];
};

export type NextAvailableGuidesInput = {
  limit: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderInput = {
  direction?: InputMaybe<OrderDirection>;
  field: Scalars['String']['input'];
};

export type PageCarousel = {
  __typename?: 'PageCarousel';
  collection: ProductCollection;
  id: Scalars['ID']['output'];
  products: Array<Product>;
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PaidAmount = {
  __typename?: 'PaidAmount';
  amount: Scalars['Float']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
};

export type PickupLocation = {
  __typename?: 'PickupLocation';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
  query: GoogleMapsQuery;
};

export type PickupLocationInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query: GoogleMapsQueryInput;
};

export enum Platform {
  GuideApp = 'GUIDE_APP',
  PartnerPortal = 'PARTNER_PORTAL',
  Storefront = 'STOREFRONT',
  VenuePortal = 'VENUE_PORTAL'
}

export type PriceTypeInput = {
  priceTypeId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type Product = {
  __typename?: 'Product';
  announcement?: Maybe<Announcement>;
  availability?: Maybe<Array<ProductAvailability>>;
  availabilityType: ProductAvailabilityType;
  cancellationLimit?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  defaultMaximumInGroup?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Array<ProductDetail>>;
  dietaryRestrictions?: Maybe<Array<DietaryRestriction>>;
  displayPrice?: Maybe<ProductDisplayPrice>;
  duration: Scalars['Int']['output'];
  earliestAvailability?: Maybe<Scalars['Date']['output']>;
  faqs?: Maybe<Array<ProductFaq>>;
  featuredGuide?: Maybe<Guide>;
  googleMapsReviewUrl?: Maybe<Scalars['String']['output']>;
  hasAccomodationVehiclePickup: Scalars['Boolean']['output'];
  hasDefaultVehiclePickup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inclusions?: Maybe<Array<ProductInclusion>>;
  influencer?: Maybe<Influencer>;
  influencerId?: Maybe<Scalars['String']['output']>;
  isCustomTour?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainPrice?: Maybe<ProductPrice>;
  maximumInGroup?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Array<ProductMedia>>;
  meetingPlaceGoogleMapsQuery?: Maybe<GoogleMapsQuery>;
  meetingPlaceGoogleMapsQueryId?: Maybe<Scalars['ID']['output']>;
  meetingPlaceGoogleMapsUrl?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<ProductMetrics>;
  minimumInGroup?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pickupLocationZone?: Maybe<LocationPickupZone>;
  poster?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<ProductPrice>>;
  privatePrices?: Maybe<Array<ProductPrivatePrice>>;
  recentPhotos?: Maybe<Array<Scalars['String']['output']>>;
  recommendedProducts?: Maybe<Array<RecommendedProductsList>>;
  requiresTransportAgreement?: Maybe<Scalars['Boolean']['output']>;
  reviewLocations?: Maybe<Array<ProductReviewLocation>>;
  reviewSummary?: Maybe<ProductReviewSummary>;
  reviews?: Maybe<ReviewsResult>;
  state?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  translation?: Maybe<ProductTranslation>;
  translations?: Maybe<Array<ProductTranslation>>;
  tripadvisorReviewUrl?: Maybe<Scalars['String']['output']>;
  willInfluencerGuide?: Maybe<Scalars['Boolean']['output']>;
  youtubes?: Maybe<Array<ProductYouTube>>;
};


export type ProductAvailabilityArgs = {
  forPrivateBooking?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum>>;
  untilDate?: InputMaybe<Scalars['Date']['input']>;
};


export type ProductDisplayPriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductEarliestAvailabilityArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  untilDate?: InputMaybe<Scalars['Date']['input']>;
};


export type ProductFaqsArgs = {
  lang?: InputMaybe<Iso639>;
};


export type ProductMainPriceArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductPricesArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductPrivatePricesArgs = {
  currency?: InputMaybe<Currency>;
};


export type ProductRecommendedProductsArgs = {
  date: Scalars['Date']['input'];
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};


export type ProductReviewsArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductTranslationArgs = {
  lang: Iso639;
};

export type ProductAvailability = {
  __typename?: 'ProductAvailability';
  date: Scalars['Date']['output'];
  status: AvailabilityStatus;
  timeSlots?: Maybe<Array<ProductAvailabilityTime>>;
};

export type ProductAvailabilityGroup = {
  __typename?: 'ProductAvailabilityGroup';
  canBecomePublic?: Maybe<Scalars['Boolean']['output']>;
  guides: Array<Guide>;
  id?: Maybe<Scalars['ID']['output']>;
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  seatsAvailable: Scalars['Int']['output'];
};

export type ProductAvailabilityTime = {
  __typename?: 'ProductAvailabilityTime';
  groups?: Maybe<Array<ProductAvailabilityGroup>>;
  status: AvailabilityStatus;
  time: Scalars['Time']['output'];
};

export enum ProductAvailabilityType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  PublicAndPrivate = 'PUBLIC_AND_PRIVATE'
}

export type ProductCollection = {
  __typename?: 'ProductCollection';
  additions?: Maybe<Array<Product>>;
  anyOrAllTags: AnyOrAllType;
  content?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  hasPage: Scalars['Boolean']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  listDescription: Scalars['String']['output'];
  listTitle: Scalars['String']['output'];
  locations?: Maybe<Array<Location>>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  omissions?: Maybe<Array<Product>>;
  products: ProductCollectionProductsResult;
  slug: Scalars['String']['output'];
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
};


export type ProductCollectionProductsArgs = {
  input?: InputMaybe<PaginationInput>;
};

export type ProductCollectionProductsResult = {
  __typename?: 'ProductCollectionProductsResult';
  records: Array<Product>;
  totalRecords: Scalars['Int']['output'];
};

export type ProductCollectionsInput = {
  hasPage?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCollectionsResult = {
  __typename?: 'ProductCollectionsResult';
  records: Array<ProductCollection>;
  totalRecords: Scalars['Int']['output'];
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  media: Array<ProductDetailMedia>;
  translation: ProductDetailTranslation;
};


export type ProductDetailTranslationArgs = {
  lang: Iso639;
};

export type ProductDetailMedia = {
  __typename?: 'ProductDetailMedia';
  mediaUrl: Scalars['String']['output'];
  type?: Maybe<ProductDetailMediaType>;
  typeId: Scalars['Int']['output'];
};

export type ProductDetailMediaType = {
  __typename?: 'ProductDetailMediaType';
  type?: Maybe<MediaType>;
};

export type ProductDetailTranslation = {
  __typename?: 'ProductDetailTranslation';
  lang: Iso639;
  name: Scalars['String']['output'];
  story: Scalars['String']['output'];
};

export type ProductDisplayPrice = {
  __typename?: 'ProductDisplayPrice';
  amount: Scalars['Float']['output'];
  currency: Currency;
  isGroup: Scalars['Boolean']['output'];
  originalPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductFaq = {
  __typename?: 'ProductFAQ';
  answer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  lang: Iso639;
  productId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type ProductInclusion = {
  __typename?: 'ProductInclusion';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  translation: ProductInclusionTranslation;
};


export type ProductInclusionTranslationArgs = {
  lang: Iso639;
};

export type ProductInclusionTranslation = {
  __typename?: 'ProductInclusionTranslation';
  description?: Maybe<Scalars['String']['output']>;
  lang: Iso639;
  title: Scalars['String']['output'];
};

export type ProductKey = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMedia = {
  __typename?: 'ProductMedia';
  category?: Maybe<MediaCategory>;
  type: MediaType;
  url: Scalars['String']['output'];
};

export type ProductMetrics = {
  __typename?: 'ProductMetrics';
  numPeople: Scalars['Int']['output'];
};

export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['ID']['output'];
  location: ProductOptionLocation;
  translation: ProductOptionTranslation;
};

export type ProductOptionLocation = {
  __typename?: 'ProductOptionLocation';
  name: Scalars['String']['output'];
};

export type ProductOptionTranslation = {
  __typename?: 'ProductOptionTranslation';
  name: Scalars['String']['output'];
};

export type ProductOptionsResult = {
  __typename?: 'ProductOptionsResult';
  records: Array<ProductOption>;
};

export enum ProductOrderField {
  Price = 'PRICE',
  Score = 'SCORE'
}

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Float']['output'];
  currency: Currency;
  excludeFromPrivateGroupCount: Scalars['Boolean']['output'];
  fixedPrices?: Maybe<Array<FixedPrice>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge: Scalars['Int']['output'];
  minimumPeople: Scalars['Int']['output'];
  originalPrice?: Maybe<Scalars['Float']['output']>;
  tags: Array<Scalars['String']['output']>;
  translation?: Maybe<ProductPriceTranslation>;
};


export type ProductPriceTranslationArgs = {
  lang: Iso639;
};

export type ProductPriceTranslation = {
  __typename?: 'ProductPriceTranslation';
  description?: Maybe<Scalars['String']['output']>;
};

export type ProductPrivatePrice = {
  __typename?: 'ProductPrivatePrice';
  id: Scalars['ID']['output'];
  minGroupSize: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type ProductReviewLocation = {
  __typename?: 'ProductReviewLocation';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  percentage: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductReviewSummary = {
  __typename?: 'ProductReviewSummary';
  average?: Maybe<Scalars['Float']['output']>;
  numReviews: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  cancellationPolicy: Scalars['String']['output'];
  featuredGuideComment?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Scalars['String']['output']>;
  lang: Iso639;
  meetingPlaceDescription?: Maybe<Scalars['String']['output']>;
  meetingPlaceName?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notIncluded?: Maybe<Scalars['String']['output']>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type ProductYouTube = {
  __typename?: 'ProductYouTube';
  title: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
};

export type ProductsInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderField?: InputMaybe<ProductOrderField>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProductsResult = {
  __typename?: 'ProductsResult';
  records: Array<Product>;
  totalRecords: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  booking?: Maybe<Booking>;
  /**
   * Describes a login token without using it up: whether it still works and
   * whose trip it opens, so the portal can ask the traveler to continue, or
   * offer to email a fresh link once it is used or expired.
   */
  bookingPortalLoginTokenStatus: BookingPortalLoginTokenStatus;
  bookingPortalPendingInvitations: Array<BookingPortalPendingInvitation>;
  bookingPortalRegistrationRequest?: Maybe<BookingPortalRegistrationRequest>;
  bulkBooking?: Maybe<BulkBooking>;
  chatMessages: ChatMessagesResponse;
  chatRoom?: Maybe<ChatRoom>;
  /**
   * Pending invitations for the checkout confirmation page, which holds no
   * portal session and is authorized only while the booking's payment is fresh.
   */
  checkoutBookingPortalInvitations: Array<BookingPortalPendingInvitation>;
  contract?: Maybe<Contract>;
  coupon?: Maybe<Coupon>;
  currentStorefrontSession?: Maybe<StorefrontSession>;
  faqs: FaqsResult;
  featuredBanners: Array<FeaturedBanner>;
  getGuestReview?: Maybe<GuestReview>;
  guide?: Maybe<Guide>;
  guideGroups: Array<Group>;
  guides: Array<Guide>;
  htmlContent: HtmlContent;
  interviewArticle?: Maybe<InterviewArticle>;
  interviewArticles: InterviewArticlesResponse;
  location: Location;
  locations: LocationsResponse;
  multidayItineraries: MultidayItinerariesResponse;
  multidayItinerary?: Maybe<MultidayItinerary>;
  nextAvailableGuides: Array<Group>;
  pageCarousels: Array<PageCarousel>;
  product?: Maybe<Product>;
  productCollection: ProductCollection;
  productCollections: ProductCollectionsResult;
  productOptions: ProductOptionsResult;
  products: ProductsResult;
  reviews: ReviewsResult;
  searchProducts: ProductsResult;
  tags: TagsResult;
  waitingListUser: WaitingListUser;
  waitingListUsers: Array<WaitingListUser>;
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingPortalLoginTokenStatusArgs = {
  token: Scalars['ID']['input'];
};


export type QueryBookingPortalPendingInvitationsArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryBookingPortalRegistrationRequestArgs = {
  token: Scalars['ID']['input'];
};


export type QueryBulkBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatMessagesArgs = {
  bookingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextId?: InputMaybe<Scalars['String']['input']>;
  prevId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatRoomArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  guideId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ChatRoomType>;
};


export type QueryCheckoutBookingPortalInvitationsArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  code: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrentStorefrontSessionArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFaqsArgs = {
  input?: InputMaybe<FaqsInput>;
};


export type QueryFeaturedBannersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  showHome?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetGuestReviewArgs = {
  guestId: Scalars['ID']['input'];
};


export type QueryGuideArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGuideGroupsArgs = {
  guideId: Scalars['ID']['input'];
  numGroups: Scalars['Int']['input'];
};


export type QueryGuidesArgs = {
  input: GuidesInput;
};


export type QueryHtmlContentArgs = {
  pageName: Scalars['String']['input'];
};


export type QueryInterviewArticleArgs = {
  slug: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  input?: InputMaybe<LocationsInput>;
};


export type QueryMultidayItinerariesArgs = {
  input?: InputMaybe<MultidayItinerariesInput>;
};


export type QueryMultidayItineraryArgs = {
  slug: Scalars['String']['input'];
};


export type QueryNextAvailableGuidesArgs = {
  input: NextAvailableGuidesInput;
};


export type QueryPageCarouselsArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  input: ProductKey;
};


export type QueryProductCollectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCollectionsArgs = {
  input?: InputMaybe<ProductCollectionsInput>;
};


export type QueryProductsArgs = {
  input?: InputMaybe<ProductsInput>;
};


export type QueryReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchProductsArgs = {
  input?: InputMaybe<SearchProductsInput>;
};


export type QueryTagsArgs = {
  hasProducts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWaitingListUserArgs = {
  accessKey: Scalars['ID']['input'];
};

export type QuestionAndAnswer = {
  __typename?: 'QuestionAndAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  faqCategory?: Maybe<Faq>;
  faqCategoryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type RecommendedProductsList = {
  __typename?: 'RecommendedProductsList';
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type RecommendedProductsListInput = {
  date: Scalars['Date']['input'];
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterNewGuestInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveAllWaitingListsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RequestEbookInput = {
  email: Scalars['String']['input'];
};

export type RescheduleBookingInput = {
  bookingId: Scalars['ID']['input'];
  isPrivate: Scalars['Boolean']['input'];
  newDate: Scalars['Date']['input'];
  newTime: Scalars['Time']['input'];
};

export type Review = {
  __typename?: 'Review';
  booking?: Maybe<Booking>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isApprovedImage?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  reviewDate: Scalars['DateTime']['output'];
  reviewerImageUrl?: Maybe<Scalars['String']['output']>;
  reviewerName?: Maybe<Scalars['String']['output']>;
  stars: Scalars['Float']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ReviewLocationSelection = {
  __typename?: 'ReviewLocationSelection';
  reviewSource: Scalars['String']['output'];
  reviewSourceUrl?: Maybe<Scalars['String']['output']>;
};

export type ReviewsResult = {
  __typename?: 'ReviewsResult';
  records?: Maybe<Array<Review>>;
  totalRecords: Scalars['Int']['output'];
};

export type SearchProductsInput = {
  fromDate: Scalars['Date']['input'];
  groupSize: Scalars['Int']['input'];
  lang?: InputMaybe<Iso639>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum>>;
  untilDate: Scalars['Date']['input'];
};

export type SendChatMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['ID']['input'];
  chatRoomId: Scalars['ID']['input'];
  media?: InputMaybe<Array<SendChatMessageMediaInput>>;
};

export type SendChatMessageMediaInput = {
  fileUrl: Scalars['String']['input'];
};

export type SendInquiryInput = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isConnectedToBokun?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  requestedTourDate?: InputMaybe<Scalars['Date']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  typeOfPartnership?: InputMaybe<Scalars['String']['input']>;
  typeOfPromotion?: InputMaybe<Scalars['String']['input']>;
};

export type SetReviewLocationInput = {
  guestId: Scalars['ID']['input'];
  highRatingReviewLocation?: InputMaybe<Scalars['String']['input']>;
  reviewRating: Scalars['Int']['input'];
};

export type StorefrontSession = {
  __typename?: 'StorefrontSession';
  bookingId?: Maybe<Scalars['ID']['output']>;
  guest?: Maybe<Guest>;
  guests: Array<Guest>;
  id: Scalars['ID']['output'];
  scope: Scalars['String']['output'];
};

export type StorefrontSessionTokens = {
  __typename?: 'StorefrontSessionTokens';
  csrf: Scalars['ID']['output'];
  sid: Scalars['ID']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  translation?: Maybe<TagTranslation>;
};


export type TagTranslationArgs = {
  lang: Iso639;
};

export type TagTranslation = {
  __typename?: 'TagTranslation';
  created: Scalars['DateTime']['output'];
  lang: Iso639;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type TagsResult = {
  __typename?: 'TagsResult';
  records: Array<Tag>;
  totalRecords: Scalars['Int']['output'];
};

export enum TimeRangeEnum {
  Afternoon = 'afternoon',
  Evening = 'evening',
  Morning = 'morning'
}

export type UpdateBookingPortalPendingInvitationInput = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrentBookingPortalGuestInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  guestId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePickupLocationInput = {
  bookingId: Scalars['ID']['input'];
  pickupLocation?: InputMaybe<PickupLocationInput>;
  sendEmailToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WaitingList = {
  __typename?: 'WaitingList';
  active: Scalars['Boolean']['output'];
  contacted: Array<Scalars['DateTime']['output']>;
  fromDate: Scalars['Date']['output'];
  groupSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  untilDate: Scalars['Date']['output'];
};

export type WaitingListUser = {
  __typename?: 'WaitingListUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  waitingLists: Array<WaitingList>;
};

export enum YesNoLimited {
  Limited = 'limited',
  No = 'no',
  Yes = 'yes'
}

export type BookingFieldsFragment = { __typename?: 'Booking', id: string, created: any, state: string, didAttend?: boolean | null, email?: string | null, givenName?: string | null, familyName?: string | null, paymentAmount: number, pickupLocation?: { __typename?: 'PickupLocation', address: string, name: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null };

export type ChatMessageEventFieldsFragment = { __typename?: 'ChatMessageEvent', id: string, created: any, type: string, groupId?: string | null, bookingId?: string | null };

export type ChatMessageMediaFieldsFragment = { __typename?: 'ChatMessageMedia', id: string, created: any, messageId: string, type: string, url: string };

export type ChatMessageFieldsFragment = { __typename?: 'ChatMessage', id: string, created?: any | null, chatRoomId: string, bookingId?: string | null, backofficeUserId?: string | null, guideId?: string | null, body: string };

export type ChatRoomFieldsFragment = { __typename?: 'ChatRoom', id: string, created?: any | null, type: string, bookingId?: string | null, guideId?: string | null };

export type GuideTranslationFieldsFragment = { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null };

export type GuideFieldsFragment = { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null };

export type LocationTranslationFieldsFragment = { __typename?: 'LocationTranslation', name: string, metaTitle?: string | null, metaDescription?: string | null, lang: Iso639 };

export type LocationFieldsFragment = { __typename?: 'Location', id: string, parentId?: string | null, countryId?: string | null, slug: string, timezone: string, country?: { __typename?: 'Location', id: string, name: string } | null };

export type PageCarouselFieldsFragment = { __typename?: 'PageCarousel', id: string, collection: { __typename?: 'ProductCollection', id: string, listTitle: string }, products: Array<{ __typename?: 'Product', id: string, poster?: string | null, duration: number, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null }> };

export type ProductAvailabilityGroupFieldsFragment = { __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number };

export type ProductAvailabilityTimeSlotsFieldsFragment = { __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, isEmpty?: boolean | null, isPrivate?: boolean | null, guides: Array<{ __typename?: 'Guide', id: string, nickName: string }> }> | null }> | null };

export type ProductAvailabilityTimeFieldsFragment = { __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus };

export type ProductAvailabilityFieldsFragment = { __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus };

export type ProductCollectionProductFieldsFragment = { __typename?: 'ProductCollection', products: { __typename?: 'ProductCollectionProductsResult', records: Array<{ __typename?: 'Product', id: string, poster?: string | null, duration: number, earliestAvailability?: any | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null }> } };

export type ProductCollectionFieldsFragment = { __typename?: 'ProductCollection', id: string, slug: string, title: string, listTitle: string, metaTitle: string, headline: string, description: string, listDescription: string, metaDescription: string, content?: string | null, imageUrl?: string | null, hasPage: boolean, lastUpdated?: any | null, locations?: Array<{ __typename?: 'Location', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null };

export type ProductDetailMediaFieldsFragment = { __typename?: 'ProductDetailMedia', typeId: number, mediaUrl: string, type?: { __typename?: 'ProductDetailMediaType', type?: MediaType | null } | null };

export type ProductDetailTranslationFieldsFragment = { __typename?: 'ProductDetailTranslation', lang: Iso639, name: string, story: string };

export type ProductDietaryRestrictionsFieldsFragment = { __typename?: 'DietaryRestriction', diet: string, memo?: string | null, isPossible: YesNoLimited };

export type ProductDisplayPriceFieldsFragment = { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null };

export type ProductFaqFieldsFragment = { __typename?: 'ProductFAQ', id: string, createdAt: any, productId: string, lang: Iso639, question: string, answer: string, index: number, imageUrl?: string | null };

export type ProductInclusionTranslationFieldsFragment = { __typename?: 'ProductInclusionTranslation', lang: Iso639, title: string, description?: string | null };

export type ProductInclusionFieldsFragment = { __typename?: 'ProductInclusion', id: string, index: number, icon?: string | null };

export type ProductMediaFieldsFragment = { __typename?: 'ProductMedia', url: string, type: MediaType, category?: { __typename?: 'MediaCategory', id: string, name: string } | null };

export type ProductPriceTranslationFieldsFragment = { __typename?: 'ProductPriceTranslation', description?: string | null };

export type ProductPriceFieldsFragment = { __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, minAge: number, maxAge?: number | null, tags: Array<string>, minimumPeople: number, originalPrice?: number | null };

export type ProductPrivatePriceFieldsFragment = { __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null };

export type ProductTranslationFieldsFragment = { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null };

export type ProductYouTubeFieldsFragment = { __typename?: 'ProductYouTube', youtubeId: string, title: string };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, defaultMaximumInGroup?: number | null, maximumInGroup?: number | null, mainImage?: string | null, name?: string | null, state?: number | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, metrics?: { __typename?: 'ProductMetrics', numPeople: number } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null };

export type ReviewFieldsFragment = { __typename?: 'Review', id: string, text?: string | null, reviewerName?: string | null, reviewDate: any, stars: number, reviewerImageUrl?: string | null, imageUrl?: string | null, isApprovedImage?: boolean | null, booking?: { __typename?: 'Booking', group: { __typename?: 'Group', date: any } } | null };

export type TagTranslationFieldsFragment = { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string };

export type TagFieldsFragment = { __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string };

export type ApproveBookingPortalRegistrationRequestMutationVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type ApproveBookingPortalRegistrationRequestMutation = { __typename?: 'Mutation', approveBookingPortalRegistrationRequest?: { __typename?: 'ApproveBookingPortalRegistrationRequestResult', success: boolean, error?: BookingPortalRegistrationRequestError | null, email?: string | null } | null };

export type DeleteAllWaitingListsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAllWaitingListsMutation = { __typename?: 'Mutation', deleteAllWaitingLists: Array<{ __typename?: 'WaitingList', id: string }> };

export type DeleteWaitingListsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteWaitingListsMutation = { __typename?: 'Mutation', deleteWaitingLists: Array<{ __typename?: 'WaitingList', id: string }> };

export type EditGuestReviewMutationVariables = Exact<{
  input: GuestReviewInput;
}>;


export type EditGuestReviewMutation = { __typename?: 'Mutation', editGuestReview?: { __typename?: 'GuestReview', score: number, reviewText?: string | null } | null };

export type EditWaitingListMutationVariables = Exact<{
  input: EditWaitingListInput;
}>;


export type EditWaitingListMutation = { __typename?: 'Mutation', editWaitingList: Array<{ __typename?: 'WaitingList', active: boolean, contacted: Array<any>, fromDate: any, groupSize: number, id: string, productId: string, untilDate: any }> };

export type EditWaitingListUserMutationVariables = Exact<{
  input: EditWaitingListUserInput;
}>;


export type EditWaitingListUserMutation = { __typename?: 'Mutation', editWaitingListUser: { __typename?: 'WaitingListUser', timeZone: string } };

export type EndStorefrontSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type EndStorefrontSessionMutation = { __typename?: 'Mutation', endStorefrontSession: boolean };

export type LoginBookingPortalMutationVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type LoginBookingPortalMutation = { __typename?: 'Mutation', loginBookingPortal: { __typename?: 'StorefrontSessionTokens', sid: string, csrf: string } };

export type RegisterBookingPortalGuestMutationVariables = Exact<{
  token: Scalars['ID']['input'];
  guest: RegisterNewGuestInput;
}>;


export type RegisterBookingPortalGuestMutation = { __typename?: 'Mutation', registerBookingPortalGuest: { __typename?: 'StorefrontSessionTokens', sid: string, csrf: string } };

export type RemoveBookingPortalGuestMutationVariables = Exact<{
  guestId: Scalars['ID']['input'];
}>;


export type RemoveBookingPortalGuestMutation = { __typename?: 'Mutation', removeBookingPortalGuest: boolean };

export type ResendBookingPortalPendingInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type ResendBookingPortalPendingInvitationMutation = { __typename?: 'Mutation', resendBookingPortalPendingInvitation: boolean };

export type RevokeBookingPortalPendingInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type RevokeBookingPortalPendingInvitationMutation = { __typename?: 'Mutation', revokeBookingPortalPendingInvitation: boolean };

export type RevokeCheckoutBookingPortalInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type RevokeCheckoutBookingPortalInvitationMutation = { __typename?: 'Mutation', revokeCheckoutBookingPortalInvitation: boolean };

export type SendBookingPortalInvitationMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  guestId?: InputMaybe<Scalars['ID']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendBookingPortalInvitationMutation = { __typename?: 'Mutation', sendBookingPortalInvitation: { __typename?: 'BookingPortalPendingInvitation', id: string } };

export type SendBookingPortalLoginTokenMutationVariables = Exact<{
  guestId?: InputMaybe<Scalars['ID']['input']>;
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  allTrips?: InputMaybe<Scalars['Boolean']['input']>;
  tab?: InputMaybe<BookingPortalTab>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  requestedFrom: BookingPortalLoginRequestedFrom;
}>;


export type SendBookingPortalLoginTokenMutation = { __typename?: 'Mutation', sendBookingPortalLoginToken: boolean };

export type SendBookingPortalRegistrationRequestMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type SendBookingPortalRegistrationRequestMutation = { __typename?: 'Mutation', sendBookingPortalRegistrationRequest: boolean };

export type SendChatMessageMutationVariables = Exact<{
  input: SendChatMessageInput;
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: { __typename?: 'ChatMessage', id: string, created?: any | null, chatRoomId: string, bookingId?: string | null, backofficeUserId?: string | null, guideId?: string | null, body: string, media?: Array<{ __typename?: 'ChatMessageMedia', id: string, created: any, messageId: string, type: string, url: string }> | null } };

export type SendCheckoutBookingPortalInvitationMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  guestId?: InputMaybe<Scalars['ID']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendCheckoutBookingPortalInvitationMutation = { __typename?: 'Mutation', sendCheckoutBookingPortalInvitation: { __typename?: 'BookingPortalPendingInvitation', id: string, bookingId: string, guestId?: string | null, email: string, givenName?: string | null, familyName?: string | null, created: any } };

export type SetReviewLocationMutationVariables = Exact<{
  input: SetReviewLocationInput;
}>;


export type SetReviewLocationMutation = { __typename?: 'Mutation', setReviewLocation: { __typename?: 'ReviewLocationSelection', reviewSource: string, reviewSourceUrl?: string | null } };

export type SignContractsMutationVariables = Exact<{
  guideId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
}>;


export type SignContractsMutation = { __typename?: 'Mutation', signContracts?: boolean | null };

export type StartCheckoutBookingPortalSessionMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type StartCheckoutBookingPortalSessionMutation = { __typename?: 'Mutation', startCheckoutBookingPortalSession: { __typename?: 'StorefrontSessionTokens', sid: string } };

export type ToggleWaitingListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ToggleWaitingListMutation = { __typename?: 'Mutation', toggleWaitingList: boolean };

export type UpdateBookingPortalPendingInvitationMutationVariables = Exact<{
  input: UpdateBookingPortalPendingInvitationInput;
}>;


export type UpdateBookingPortalPendingInvitationMutation = { __typename?: 'Mutation', updateBookingPortalPendingInvitation: boolean };

export type UpdateCurrentBookingPortalGuestMutationVariables = Exact<{
  input: UpdateCurrentBookingPortalGuestInput;
}>;


export type UpdateCurrentBookingPortalGuestMutation = { __typename?: 'Mutation', updateCurrentBookingPortalGuest: boolean };

export type GetAllCountriesQueryVariables = Exact<{
  input?: InputMaybe<LocationsInput>;
}>;


export type GetAllCountriesQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, name: string }> } };

export type GetAllLocationIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLocationIdsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, slug: string, country?: { __typename?: 'Location', id: string, name: string } | null }> } };

export type GetAllProductCollectionSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductCollectionSlugsQuery = { __typename?: 'Query', productCollections: { __typename?: 'ProductCollectionsResult', totalRecords: number, records: Array<{ __typename?: 'ProductCollection', slug: string }> } };

export type GetAllProductOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductOptionsQuery = { __typename?: 'Query', productOptions: { __typename?: 'ProductOptionsResult', records: Array<{ __typename?: 'ProductOption', id: string, translation: { __typename?: 'ProductOptionTranslation', name: string }, location: { __typename?: 'ProductOptionLocation', name: string } }> } };

export type GetAvailableGuidesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  lang: Iso639;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetAvailableGuidesQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, reviewSummary?: { __typename?: 'GuideReviewSummary', average?: number | null, numReviews: number } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null }> }> | null }> | null }> | null } | null };

export type GetBookingQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, state: string, paymentAmount: number, currency?: string | null, email?: string | null, familyName?: string | null, givenName?: string | null, numPeople?: number | null, phoneNumber?: string | null, isPrivate?: boolean | null, created: any, bookingSourceId?: string | null, paidAmount?: { __typename?: 'PaidAmount', state: string, amount: number, currency: Currency } | null, payments: Array<{ __typename?: 'Payment', id: string, state: string, amount: number, currency: Currency, description?: string | null }>, source?: { __typename?: 'BookingSource', name: string } | null, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null, guests: Array<{ __typename?: 'Guest', id: string, index: number, isLeadGuest: boolean, givenName: string, familyName: string, email?: string | null, phoneNumber?: string | null }>, group: { __typename?: 'Group', date: any, time: any, hasEnded: boolean, customGroupItinerary?: Array<{ __typename?: 'CustomGroupItinerary', id: string, stepDescription: string, stepOrder: number }> | null, guideAssignments: Array<{ __typename?: 'GuideAssignment', role: string, guide: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null } }>, media: Array<{ __typename?: 'GroupMedia', url: string, type: string }>, product: { __typename?: 'Product', id: string, duration: number, isCustomTour?: boolean | null, requiresTransportAgreement?: boolean | null, minimumInGroup?: number | null, tripadvisorReviewUrl?: string | null, googleMapsReviewUrl?: string | null, meetingPlaceGoogleMapsUrl?: string | null, poster?: string | null, reviewLocations?: Array<{ __typename?: 'ProductReviewLocation', label: string, url?: string | null }> | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null, faqs?: Array<{ __typename?: 'ProductFAQ', id: string, question: string, answer: string, index: number }> | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null, itinerary?: string | null, meetingPlaceDescription?: string | null, meetingPlaceName?: string | null } | null } } } | null };

export type GetBookingCheckoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  languageCode: Iso639;
  currencyCode: Currency;
}>;


export type GetBookingCheckoutQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, state: string, created: any, isPrivate?: boolean | null, email?: string | null, phoneNumber?: string | null, couponCode?: string | null, numConfirmedBookings: number, bookingSourceId?: string | null, reviewRating?: number | null, paymentAmount: number, currency?: string | null, paidAmount?: { __typename?: 'PaidAmount', state: string, amount: number, currency: Currency } | null, payments: Array<{ __typename?: 'Payment', id: string, state: string, amount: number, currency: Currency, description?: string | null }>, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null, coupon?: { __typename?: 'Coupon', amount: number, code: string, type: CouponType } | null, details?: Array<{ __typename?: 'BookingDetail', quantity: number, unitAmount: number, productPrice: { __typename?: 'ProductPrice', excludeFromPrivateGroupCount: boolean, minAge: number, maxAge?: number | null, tags: Array<string>, amount: number, id: string, currency: Currency } }> | null, group: { __typename?: 'Group', id: string, date: any, time: any, isPrivate: boolean, customGroupItinerary?: Array<{ __typename?: 'CustomGroupItinerary', id: string, stepDescription: string, stepOrder: number }> | null, product: { __typename?: 'Product', id: string, requiresTransportAgreement?: boolean | null, isCustomTour?: boolean | null, minimumInGroup?: number | null, hasDefaultVehiclePickup: boolean, hasAccomodationVehiclePickup: boolean, meetingPlaceGoogleMapsUrl?: string | null, availabilityType: ProductAvailabilityType, cancellationLimit?: number | null, currency?: string | null, defaultMaximumInGroup?: number | null, poster?: string | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, location?: { __typename?: 'Location', countryId?: string | null, translation: { __typename?: 'LocationTranslation', name: string } } | null, translation?: { __typename?: 'ProductTranslation', name: string, itinerary?: string | null, meetingPlaceDescription?: string | null, meetingPlaceName?: string | null } | null, prices?: Array<{ __typename?: 'ProductPrice', id: string, amount: number, currency: Currency, minAge: number, maxAge?: number | null, tags: Array<string>, translation?: { __typename?: 'ProductPriceTranslation', description?: string | null } | null }> | null, privatePrices?: Array<{ __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null }> | null } } } | null };

export type GetBookingDetailsQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  currency: Currency;
}>;


export type GetBookingDetailsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', details?: Array<{ __typename?: 'BookingDetail', quantity: number, unitAmount: number, productPrice: { __typename?: 'ProductPrice', excludeFromPrivateGroupCount: boolean, minAge: number, maxAge?: number | null, tags: Array<string> } }> | null } | null };

export type GetBookingPortalGuestsQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetBookingPortalGuestsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, numPeople?: number | null, openInvitationCount: number, group: { __typename?: 'Group', id: string, date: any, product: { __typename?: 'Product', id: string, name?: string | null, poster?: string | null } }, guests: Array<{ __typename?: 'Guest', index: number, isLeadGuest: boolean, id: string, givenName: string, maskedEmail?: string | null }> } | null };

export type GetBookingPortalLoginTokenStatusQueryVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type GetBookingPortalLoginTokenStatusQuery = { __typename?: 'Query', bookingPortalLoginTokenStatus: { __typename?: 'BookingPortalLoginTokenStatus', state: BookingPortalLoginTokenState, guestId?: string | null, guestGivenName?: string | null, guestMaskedEmail?: string | null, bookingId?: string | null, tourName?: string | null, tourDate?: any | null, tourPoster?: string | null } };

export type GetBookingPortalPendingInvitationsQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetBookingPortalPendingInvitationsQuery = { __typename?: 'Query', bookingPortalPendingInvitations: Array<{ __typename?: 'BookingPortalPendingInvitation', id: string, bookingId: string, guestId?: string | null, created: any, email: string, givenName?: string | null, familyName?: string | null, phoneNumber?: string | null }> };

export type GetBookingPortalRegistrationRequestQueryVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type GetBookingPortalRegistrationRequestQuery = { __typename?: 'Query', bookingPortalRegistrationRequest?: { __typename?: 'BookingPortalRegistrationRequest', bookingId: string, email: string, familyName?: string | null, givenName?: string | null, id: string, phoneNumber?: string | null, token: string, approvedAt?: any | null, guest?: { __typename?: 'Guest', id: string, givenName: string, familyName: string } | null, booking: { __typename?: 'Booking', id: string, group: { __typename?: 'Group', date: any, id: string, time: any, product: { __typename?: 'Product', id: string, name?: string | null, poster?: string | null } }, leadGuest?: { __typename?: 'Guest', familyName: string, givenName: string } | null } } | null };

export type GetBookingWithChatRoomQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetBookingWithChatRoomQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, state: string, paymentAmount: number, currency?: string | null, email?: string | null, isPrivate?: boolean | null, created: any, leadGuest?: { __typename?: 'Guest', givenName: string, familyName: string } | null, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null, chatRoom?: { __typename?: 'ChatRoom', id: string, created?: any | null, type: string, bookingId?: string | null, guideId?: string | null } | null, group: { __typename?: 'Group', date: any, time: any, customGroupItinerary?: Array<{ __typename?: 'CustomGroupItinerary', id: string, stepDescription: string, stepOrder: number }> | null, guideAssignments: Array<{ __typename?: 'GuideAssignment', role: string, guide: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null } }>, product: { __typename?: 'Product', minimumInGroup?: number | null, meetingPlaceGoogleMapsUrl?: string | null, poster?: string | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null, translation?: { __typename?: 'ProductTranslation', name: string, itinerary?: string | null, meetingPlaceDescription?: string | null, meetingPlaceName?: string | null } | null } } } | null };

export type GetChatMessagesQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  prevId?: InputMaybe<Scalars['String']['input']>;
  nextId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChatMessagesQuery = { __typename?: 'Query', chatMessages: { __typename?: 'ChatMessagesResponse', totalCount: number, hasMore: boolean, messages: Array<{ __typename?: 'ChatMessage', id: string, created?: any | null, chatRoomId: string, bookingId?: string | null, backofficeUserId?: string | null, guideId?: string | null, body: string, booking?: { __typename?: 'Booking', id: string, created: any, state: string, didAttend?: boolean | null, email?: string | null, givenName?: string | null, familyName?: string | null, paymentAmount: number, leadGuest?: { __typename?: 'Guest', givenName: string, familyName: string } | null, pickupLocation?: { __typename?: 'PickupLocation', address: string, name: string, query: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } } | null } | null, guide?: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null } | null, media?: Array<{ __typename?: 'ChatMessageMedia', id: string, created: any, messageId: string, type: string, url: string }> | null }> } };

export type GetCheckoutBookingPortalInvitationsQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetCheckoutBookingPortalInvitationsQuery = { __typename?: 'Query', checkoutBookingPortalInvitations: Array<{ __typename?: 'BookingPortalPendingInvitation', id: string, bookingId: string, guestId?: string | null, email: string, givenName?: string | null, familyName?: string | null, created: any }> };

export type GetCitiesAndPrefecturesWithProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCitiesAndPrefecturesWithProductsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, slug: string, destinationNames?: string | null, navImageUrl?: string | null, country?: { __typename?: 'Location', id: string, name: string } | null, translation: { __typename?: 'LocationTranslation', name: string } }> } };

export type GetCityAvailableProductsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  language: Iso639;
  currency: Currency;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetCityAvailableProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', totalRecords: number, records: Array<{ __typename?: 'Product', id: string, duration: number, mainImage?: string | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus }> | null, translation?: { __typename?: 'ProductTranslation', name: string } | null, tags?: Array<{ __typename?: 'Tag', id: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null }> } };

export type GetCountriesCitiesAndPrefecturesWithProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesCitiesAndPrefecturesWithProductsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, destinationNames?: string | null, country?: { __typename?: 'Location', id: string, name: string } | null, translation: { __typename?: 'LocationTranslation', name: string } }> } };

export type GetCurrentStorefrontSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentStorefrontSessionQuery = { __typename?: 'Query', currentStorefrontSession?: { __typename?: 'StorefrontSession', id: string, guests: Array<{ __typename?: 'Guest', email?: string | null, familyName: string, givenName: string, id: string, phoneNumber?: string | null, isLeadGuest: boolean, review?: { __typename?: 'GuestReview', id: string, score: number, reviewText?: string | null } | null, booking: { __typename?: 'Booking', id: string, numPeople?: number | null, guests: Array<{ __typename?: 'Guest', id: string, isLeadGuest: boolean, familyName: string, givenName: string, email?: string | null, phoneNumber?: string | null }>, group: { __typename?: 'Group', id: string, date: any, time: any, hasMedia: boolean, guideAssignments: Array<{ __typename?: 'GuideAssignment', role: string, guide: { __typename?: 'Guide', nickName: string, profilePic?: string | null, translation?: { __typename?: 'GuideTranslation', description?: string | null } | null } }>, product: { __typename?: 'Product', id: string, name?: string | null, poster?: string | null, duration: number, location?: { __typename?: 'Location', name: string, country?: { __typename?: 'Location', name: string } | null } | null } } } }> } | null };

export type GetCurrentStorefrontSessionForPortalQueryVariables = Exact<{
  bookingId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetCurrentStorefrontSessionForPortalQuery = { __typename?: 'Query', currentStorefrontSession?: { __typename?: 'StorefrontSession', id: string, bookingId?: string | null, scope: string, guest?: { __typename?: 'Guest', id: string, bookingId: string, email?: string | null, familyName: string, givenName: string, phoneNumber?: string | null, isLeadGuest: boolean, review?: { __typename?: 'GuestReview', id: string, score: number, reviewText?: string | null } | null, booking: { __typename?: 'Booking', id: string, numPeople?: number | null } } | null, guests: Array<{ __typename?: 'Guest', email?: string | null, familyName: string, givenName: string, id: string, phoneNumber?: string | null, isLeadGuest: boolean, review?: { __typename?: 'GuestReview', id: string, score: number, reviewText?: string | null } | null, booking: { __typename?: 'Booking', id: string, numPeople?: number | null, guests: Array<{ __typename?: 'Guest', id: string, isLeadGuest: boolean, familyName: string, givenName: string, email?: string | null, phoneNumber?: string | null }>, group: { __typename?: 'Group', id: string, date: any, time: any, hasEnded: boolean, hasMedia: boolean, guideAssignments: Array<{ __typename?: 'GuideAssignment', role: string, guide: { __typename?: 'Guide', nickName: string, profilePic?: string | null, translation?: { __typename?: 'GuideTranslation', description?: string | null } | null } }>, product: { __typename?: 'Product', id: string, name?: string | null, poster?: string | null, duration: number, location?: { __typename?: 'Location', name: string, country?: { __typename?: 'Location', name: string } | null } | null } } } }> } | null };

export type GetCustomTourFaqsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomTourFaqsQuery = { __typename?: 'Query', faqs: { __typename?: 'FaqsResult', records: Array<{ __typename?: 'Faq', id: string, questionsAndAnswers?: Array<{ __typename?: 'QuestionAndAnswer', id: string, question?: string | null, answer?: string | null } | null> | null }> } };

export type GetFeaturedBannersQueryVariables = Exact<{
  showHome?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFeaturedBannersQuery = { __typename?: 'Query', featuredBanners: Array<{ __typename?: 'FeaturedBanner', title: string, imageUrl: string, pageUrl: string, ctaText: string }> };

export type GetGuestReviewQueryVariables = Exact<{
  guestId: Scalars['ID']['input'];
}>;


export type GetGuestReviewQuery = { __typename?: 'Query', getGuestReview?: { __typename?: 'GuestReview', reviewSource: string, reviewSourceUrl?: string | null } | null };

export type GetLocationItinerariesQueryVariables = Exact<{
  input?: InputMaybe<MultidayItinerariesInput>;
}>;


export type GetLocationItinerariesQuery = { __typename?: 'Query', multidayItineraries: { __typename?: 'MultidayItinerariesResponse', records: Array<{ __typename?: 'MultidayItinerary', id: string, name: string, slug: string, description: string, imageThumbnail?: string | null, location?: { __typename?: 'Location', translations: Array<{ __typename?: 'LocationTranslation', lang: Iso639, name: string }>, country?: { __typename?: 'Location', name: string } | null } | null, days?: Array<{ __typename?: 'MultidayItineraryDay', id: string, blocks?: Array<{ __typename?: 'MultidayItineraryBlock', id: string, type: string }> | null }> | null }> } };
export type GetInterviewArticleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang: Iso639;
  currency: Currency;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetInterviewArticleQuery = { __typename?: 'Query', interviewArticle?: { __typename?: 'InterviewArticle', id: string, slug: string, title: string, content: string, metaTitle?: string | null, metaDescription?: string | null, products: Array<{ __typename?: 'Product', id: string, poster?: string | null, duration: number, earliestAvailability?: any | null, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus }> | null }> } | null };

export type GetMultidayItinerariesListQueryVariables = Exact<{
  input?: InputMaybe<MultidayItinerariesInput>;
}>;


export type GetMultidayItinerariesListQuery = { __typename?: 'Query', multidayItineraries: { __typename?: 'MultidayItinerariesResponse', totalRecords: number, records: Array<{ __typename?: 'MultidayItinerary', id: string, name: string, slug: string, description: string, imageThumbnail?: string | null, published?: boolean | null, location?: { __typename?: 'Location', translations: Array<{ __typename?: 'LocationTranslation', lang: Iso639, name: string }>, country?: { __typename?: 'Location', name: string } | null } | null, days?: Array<{ __typename?: 'MultidayItineraryDay', id: string, blocks?: Array<{ __typename?: 'MultidayItineraryBlock', id: string, type: string }> | null }> | null }> } };

export type GetMultidayItineraryQueryVariables = Exact<{
  multidayItinerarySlug: Scalars['String']['input'];
}>;


export type GetMultidayItineraryQuery = { __typename?: 'Query', multidayItinerary?: { __typename?: 'MultidayItinerary', id: string, name: string, slug: string, description: string, bannerTitle?: string | null, bannerDescription?: string | null, locationId: string, published?: boolean | null, created?: any | null, metaDescription?: string | null, imageUrl?: string | null, imageThumbnail?: string | null, metaTitle?: string | null, lastPublished?: any | null, location?: { __typename?: 'Location', id: string, slug: string, translations: Array<{ __typename?: 'LocationTranslation', lang: Iso639, id: string, name: string }>, country?: { __typename?: 'Location', id: string, name: string } | null } | null, days?: Array<{ __typename?: 'MultidayItineraryDay', id: string, dayNumber: number, title?: string | null, description?: string | null, blocks?: Array<{ __typename?: 'MultidayItineraryBlock', id: string, type: string, content?: string | null, time?: string | null, title: string, stepOrder: number, product?: { __typename?: 'Product', id: string, poster?: string | null, tags?: Array<{ __typename?: 'Tag', id: string } | null> | null, translations?: Array<{ __typename?: 'ProductTranslation', name: string, lang: Iso639 }> | null } | null }> | null }> | null } | null };

export type NextAvailableGuidesQueryVariables = Exact<{
  input: NextAvailableGuidesInput;
  lang: Iso639;
}>;


export type NextAvailableGuidesQuery = { __typename?: 'Query', nextAvailableGuides: Array<{ __typename?: 'Group', id: string, date: any, time: any, mainGuide?: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null, translation?: { __typename?: 'GuideTranslation', description?: string | null } | null } | null }> };

export type GetPageCarouselsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  currency: Currency;
  lang: Iso639;
}>;


export type GetPageCarouselsQuery = { __typename?: 'Query', pageCarousels: Array<{ __typename?: 'PageCarousel', id: string, collection: { __typename?: 'ProductCollection', id: string, listTitle: string }, products: Array<{ __typename?: 'Product', id: string, poster?: string | null, duration: number, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null }> }> };

export type GetPosterProductsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  language: Iso639;
  currency: Currency;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetPosterProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', totalRecords: number, records: Array<{ __typename?: 'Product', id: string, duration: number, poster?: string | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null }> } };

export type GetProductQueryVariables = Exact<{
  productKey: ProductKey;
  currency?: InputMaybe<Currency>;
  lang: Iso639;
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', recentPhotos?: Array<string> | null, requiresTransportAgreement?: boolean | null, willInfluencerGuide?: boolean | null, hasAccomodationVehiclePickup: boolean, hasDefaultVehiclePickup: boolean, id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, defaultMaximumInGroup?: number | null, maximumInGroup?: number | null, mainImage?: string | null, name?: string | null, state?: number | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, announcement?: { __typename?: 'Announcement', content: string, active: boolean } | null, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, prices?: Array<{ __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, minAge: number, maxAge?: number | null, tags: Array<string>, minimumPeople: number, originalPrice?: number | null }> | null, privatePrices?: Array<{ __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null }> | null, faqs?: Array<{ __typename?: 'ProductFAQ', id: string, createdAt: any, productId: string, lang: Iso639, question: string, answer: string, index: number, imageUrl?: string | null }> | null, featuredGuide?: { __typename?: 'Guide', isActive?: boolean | null, id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null } | null, youtubes?: Array<{ __typename?: 'ProductYouTube', youtubeId: string, title: string }> | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, media?: Array<{ __typename?: 'ProductMedia', url: string, type: MediaType, category?: { __typename?: 'MediaCategory', id: string, name: string } | null }> | null, details?: Array<{ __typename?: 'ProductDetail', media: Array<{ __typename?: 'ProductDetailMedia', typeId: number, mediaUrl: string, type?: { __typename?: 'ProductDetailMediaType', type?: MediaType | null } | null }>, translation: { __typename?: 'ProductDetailTranslation', lang: Iso639, name: string, story: string } }> | null, location?: { __typename?: 'Location', id: string, parentId?: string | null, countryId?: string | null, slug: string, timezone: string, translation: { __typename?: 'LocationTranslation', name: string, metaTitle?: string | null, metaDescription?: string | null, lang: Iso639 }, country?: { __typename?: 'Location', id: string, name: string } | null } | null, inclusions?: Array<{ __typename?: 'ProductInclusion', id: string, index: number, icon?: string | null, translation: { __typename?: 'ProductInclusionTranslation', lang: Iso639, title: string, description?: string | null } }> | null, dietaryRestrictions?: Array<{ __typename?: 'DietaryRestriction', diet: string, memo?: string | null, isPossible: YesNoLimited }> | null, influencer?: { __typename?: 'Influencer', id: string, name: string, tiktokUrl?: string | null, xUrl?: string | null, youtubeUrl?: string | null, instagramUrl?: string | null, iconSrc: string, guide?: { __typename?: 'Guide', id: string, nickName: string } | null } | null, pickupLocationZone?: { __typename?: 'LocationPickupZone', radius: number, center: { __typename?: 'LocationCenter', lat: number, lng: number } } | null, metrics?: { __typename?: 'ProductMetrics', numPeople: number } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null } | null };

export type GetProductAnnouncementQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetProductAnnouncementQuery = { __typename?: 'Query', product?: { __typename?: 'Product', announcement?: { __typename?: 'Announcement', content: string, active: boolean } | null } | null };

export type GetProductAvailabilitiesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  lang: Iso639;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductAvailabilitiesQuery = { __typename?: 'Query', product?: { __typename?: 'Product', availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, translation?: { __typename?: 'GuideTranslation', language: Iso639, description?: string | null, hobbies?: Array<string | null> | null } | null, languages?: Array<{ __typename?: 'Language', iso639_1: string, name: string }> | null, media?: Array<{ __typename?: 'GuideMedia', type: string, url: string }> | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null }> }> | null }> | null }> | null } | null };

export type GetProductAvailabilityQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductAvailabilityQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, location?: { __typename?: 'Location', timezone: string } | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', id?: string | null, seatsAvailable: number, isEmpty?: boolean | null, isPrivate?: boolean | null, canBecomePublic?: boolean | null, guides: Array<{ __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, profileVideo?: string | null, reviewSummary?: { __typename?: 'GuideReviewSummary', average?: number | null, numReviews: number } | null }> }> | null }> | null }> | null } | null };

export type GetProductAvailabilityStatusQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductAvailabilityStatusQuery = { __typename?: 'Query', product?: { __typename?: 'Product', availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus }> | null } | null };

export type GetProductCardsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  language: Iso639;
  currency: Currency;
  tags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProductCardsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', totalRecords: number, records: Array<{ __typename?: 'Product', id: string, duration: number, poster?: string | null, translation?: { __typename?: 'ProductTranslation', name: string } | null, location?: { __typename?: 'Location', translation: { __typename?: 'LocationTranslation', name: string } } | null, tags?: Array<{ __typename?: 'Tag', id: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null }> } };

export type GetProductCollectionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
  currency: Currency;
  lang: Iso639;
}>;


export type GetProductCollectionQuery = { __typename?: 'Query', productCollection: { __typename?: 'ProductCollection', id: string, slug: string, title: string, listTitle: string, metaTitle: string, headline: string, description: string, listDescription: string, metaDescription: string, content?: string | null, imageUrl?: string | null, hasPage: boolean, lastUpdated?: any | null, locations?: Array<{ __typename?: 'Location', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, products: { __typename?: 'ProductCollectionProductsResult', records: Array<{ __typename?: 'Product', id: string, poster?: string | null, duration: number, earliestAvailability?: any | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null }> } } };

export type GetProductCollectionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  currency: Currency;
  lang: Iso639;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductCollectionsQuery = { __typename?: 'Query', productCollections: { __typename?: 'ProductCollectionsResult', totalRecords: number, records: Array<{ __typename?: 'ProductCollection', id: string, slug: string, title: string, listTitle: string, metaTitle: string, headline: string, description: string, listDescription: string, metaDescription: string, content?: string | null, imageUrl?: string | null, hasPage: boolean, lastUpdated?: any | null, locations?: Array<{ __typename?: 'Location', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, products: { __typename?: 'ProductCollectionProductsResult', records: Array<{ __typename?: 'Product', id: string, poster?: string | null, duration: number, earliestAvailability?: any | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null }> } }> } };

export type GetProductPriceQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  currency?: InputMaybe<Currency>;
}>;


export type GetProductPriceQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null } | null };

export type GetProductReviewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetProductReviewsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, defaultMaximumInGroup?: number | null, maximumInGroup?: number | null, mainImage?: string | null, name?: string | null, state?: number | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, reviews?: { __typename?: 'ReviewsResult', totalRecords: number, records?: Array<{ __typename?: 'Review', id: string, text?: string | null, reviewerName?: string | null, reviewDate: any, stars: number, reviewerImageUrl?: string | null, imageUrl?: string | null, isApprovedImage?: boolean | null, booking?: { __typename?: 'Booking', group: { __typename?: 'Group', date: any } } | null }> | null } | null, metrics?: { __typename?: 'ProductMetrics', numPeople: number } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null } | null };

export type GetProductsQueryVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Currency>;
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  lang: Iso639;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum> | TimeRangeEnum>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', records: Array<{ __typename?: 'Product', id: string, created: any, lastUpdated?: any | null, duration: number, poster?: string | null, meetingPlaceGoogleMapsUrl?: string | null, defaultMaximumInGroup?: number | null, maximumInGroup?: number | null, mainImage?: string | null, name?: string | null, state?: number | null, cancellationLimit?: number | null, availabilityType: ProductAvailabilityType, prices?: Array<{ __typename?: 'ProductPrice', amount: number, currency: Currency, excludeFromPrivateGroupCount: boolean, id: string, minAge: number, maxAge?: number | null, tags: Array<string>, minimumPeople: number, originalPrice?: number | null }> | null, translation?: { __typename?: 'ProductTranslation', lang: Iso639, name: string, headline?: string | null, highlights?: string | null, included?: string | null, notIncluded?: string | null, remarks?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null, featuredGuideComment?: string | null, itinerary?: string | null, cancellationPolicy: string, ogTitle?: string | null, ogDescription?: string | null, metaDescription?: string | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, type: MediaType, category?: { __typename?: 'MediaCategory', id: string, name: string } | null }> | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null, tags?: Array<{ __typename?: 'Tag', id: string, created: any, lastUpdated?: any | null, name: string, translation?: { __typename?: 'TagTranslation', created: any, lastUpdated?: any | null, lang: Iso639, name: string } | null } | null> | null, mainPrice?: { __typename?: 'ProductPrice', amount: number, currency: Currency } | null, privatePrices?: Array<{ __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null }> | null, availability?: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus }> | null }> | null, metrics?: { __typename?: 'ProductMetrics', numPeople: number } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null }> } };

export type GetSearchProductsQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  groupSize: Scalars['Int']['input'];
  lang: Iso639;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timeRanges?: InputMaybe<Array<TimeRangeEnum> | TimeRangeEnum>;
  untilDate: Scalars['Date']['input'];
  currency?: InputMaybe<Currency>;
}>;


export type GetSearchProductsQuery = { __typename?: 'Query', searchProducts: { __typename?: 'ProductsResult', records: Array<{ __typename?: 'Product', id: string, earliestAvailability?: any | null, poster?: string | null, duration: number, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency, isGroup: boolean, originalPrice?: number | null } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', numReviews: number, average?: number | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, translation?: { __typename?: 'TagTranslation', name: string } | null } | null> | null, translation?: { __typename?: 'ProductTranslation', name: string, headline?: string | null } | null }> } };

export type GetTagOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagOptionsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsResult', records: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type GetWaitingListUserQueryVariables = Exact<{
  accessKey: Scalars['ID']['input'];
}>;


export type GetWaitingListUserQuery = { __typename?: 'Query', waitingListUser: { __typename?: 'WaitingListUser', id?: string | null, email?: string | null, phoneNumber?: string | null, timeZone: string, waitingLists: Array<{ __typename?: 'WaitingList', id: string, productId: string, fromDate: any, untilDate: any, groupSize: number, active: boolean }> } };

export type GetYoutuberProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  language: Iso639;
  currency: Currency;
}>;


export type GetYoutuberProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, translation?: { __typename?: 'ProductTranslation', name: string } | null, displayPrice?: { __typename?: 'ProductDisplayPrice', amount: number, currency: Currency } | null, reviewSummary?: { __typename?: 'ProductReviewSummary', average?: number | null, numReviews: number } | null } | null };

export type GuideTabDataQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GuideTabDataQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', group: { __typename?: 'Group', date: any, time: any, hasEnded: boolean, product: { __typename?: 'Product', duration: number, location?: { __typename?: 'Location', timezone: string } | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null }, guideAssignments: Array<{ __typename?: 'GuideAssignment', role: string, lastKnownLocation?: { __typename?: 'LastKnownLocation', dateTime: any, lat: number, lng: number } | null, guide: { __typename?: 'Guide', id: string, nickName: string, profilePic?: string | null, languages?: Array<{ __typename?: 'Language', name: string }> | null, metrics?: { __typename?: 'GuideMetrics', numTours: number, numPeople: number } | null, reviewSummary?: { __typename?: 'GuideReviewSummary', average?: number | null, numReviews: number } | null, translation?: { __typename?: 'GuideTranslation', description?: string | null, hobbies?: Array<string | null> | null } | null } }> } } | null };

export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  id
  created
  state
  didAttend
  email
  givenName
  familyName
  paymentAmount
  pickupLocation {
    address
    name
    query {
      placeId
      geoLocation {
        lat
        lng
      }
    }
  }
}
    `;
export const ChatMessageEventFieldsFragmentDoc = gql`
    fragment ChatMessageEventFields on ChatMessageEvent {
  id
  created
  type
  groupId
  bookingId
}
    `;
export const ChatMessageMediaFieldsFragmentDoc = gql`
    fragment ChatMessageMediaFields on ChatMessageMedia {
  id
  created
  messageId
  type
  url
}
    `;
export const ChatMessageFieldsFragmentDoc = gql`
    fragment ChatMessageFields on ChatMessage {
  id
  created
  chatRoomId
  bookingId
  backofficeUserId
  guideId
  body
}
    `;
export const ChatRoomFieldsFragmentDoc = gql`
    fragment ChatRoomFields on ChatRoom {
  id
  created
  type
  bookingId
  guideId
}
    `;
export const GuideTranslationFieldsFragmentDoc = gql`
    fragment GuideTranslationFields on GuideTranslation {
  language
  description
  hobbies
}
    `;
export const GuideFieldsFragmentDoc = gql`
    fragment GuideFields on Guide {
  id
  nickName
  profilePic
  profileVideo
  languages {
    iso639_1
    name
  }
  media {
    type
    url
  }
  metrics {
    numTours
    numPeople
  }
}
    `;
export const LocationTranslationFieldsFragmentDoc = gql`
    fragment LocationTranslationFields on LocationTranslation {
  name
  metaTitle
  metaDescription
  lang
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment LocationFields on Location {
  id
  parentId
  countryId
  slug
  timezone
  country {
    id
    name
  }
}
    `;
export const ProductDisplayPriceFieldsFragmentDoc = gql`
    fragment ProductDisplayPriceFields on ProductDisplayPrice {
  amount
  currency
  isGroup
  originalPrice
}
    `;
export const PageCarouselFieldsFragmentDoc = gql`
    fragment PageCarouselFields on PageCarousel {
  id
  collection {
    id
    listTitle
  }
  products {
    id
    poster
    duration
    translation(lang: $lang) {
      name
      headline
    }
    reviewSummary {
      average
      numReviews
    }
    displayPrice(currency: $currency) {
      ...ProductDisplayPriceFields
    }
  }
}
    `;
export const ProductAvailabilityGroupFieldsFragmentDoc = gql`
    fragment ProductAvailabilityGroupFields on ProductAvailabilityGroup {
  id
  seatsAvailable
}
    `;
export const ProductAvailabilityTimeSlotsFieldsFragmentDoc = gql`
    fragment ProductAvailabilityTimeSlotsFields on ProductAvailability {
  date
  status
  timeSlots {
    time
    status
    groups {
      id
      seatsAvailable
      isEmpty
      isPrivate
      guides {
        id
        nickName
      }
    }
  }
}
    `;
export const ProductAvailabilityTimeFieldsFragmentDoc = gql`
    fragment ProductAvailabilityTimeFields on ProductAvailabilityTime {
  time
  status
}
    `;
export const ProductAvailabilityFieldsFragmentDoc = gql`
    fragment ProductAvailabilityFields on ProductAvailability {
  date
  status
}
    `;
export const ProductCollectionProductFieldsFragmentDoc = gql`
    fragment ProductCollectionProductFields on ProductCollection {
  products {
    records {
      id
      poster
      duration
      translation(lang: $lang) {
        name
        headline
      }
      displayPrice(currency: $currency) {
        ...ProductDisplayPriceFields
      }
      reviewSummary {
        average
        numReviews
      }
      tags {
        id
        name
        translation(lang: $lang) {
          name
        }
      }
      earliestAvailability(fromDate: $fromDate, untilDate: $untilDate)
    }
  }
}
    `;
export const ProductCollectionFieldsFragmentDoc = gql`
    fragment ProductCollectionFields on ProductCollection {
  id
  slug
  title
  listTitle
  metaTitle
  headline
  description
  listDescription
  metaDescription
  content
  imageUrl
  hasPage
  lastUpdated
  locations {
    id
  }
  tags {
    id
  }
}
    `;
export const ProductDetailMediaFieldsFragmentDoc = gql`
    fragment ProductDetailMediaFields on ProductDetailMedia {
  typeId
  mediaUrl
  type {
    type
  }
}
    `;
export const ProductDetailTranslationFieldsFragmentDoc = gql`
    fragment ProductDetailTranslationFields on ProductDetailTranslation {
  lang
  name
  story
}
    `;
export const ProductDietaryRestrictionsFieldsFragmentDoc = gql`
    fragment ProductDietaryRestrictionsFields on DietaryRestriction {
  diet
  memo
  isPossible
}
    `;
export const ProductFaqFieldsFragmentDoc = gql`
    fragment ProductFAQFields on ProductFAQ {
  id
  createdAt
  productId
  lang
  question
  answer
  index
  imageUrl
}
    `;
export const ProductInclusionTranslationFieldsFragmentDoc = gql`
    fragment ProductInclusionTranslationFields on ProductInclusionTranslation {
  lang
  title
  description
}
    `;
export const ProductInclusionFieldsFragmentDoc = gql`
    fragment ProductInclusionFields on ProductInclusion {
  id
  index
  icon
}
    `;
export const ProductMediaFieldsFragmentDoc = gql`
    fragment ProductMediaFields on ProductMedia {
  url
  type
  category {
    id
    name
  }
}
    `;
export const ProductPriceTranslationFieldsFragmentDoc = gql`
    fragment ProductPriceTranslationFields on ProductPriceTranslation {
  description
}
    `;
export const ProductPriceFieldsFragmentDoc = gql`
    fragment ProductPriceFields on ProductPrice {
  amount
  currency
  excludeFromPrivateGroupCount
  id
  minAge
  maxAge
  tags
  minimumPeople
  originalPrice
}
    `;
export const ProductPrivatePriceFieldsFragmentDoc = gql`
    fragment ProductPrivatePriceFields on ProductPrivatePrice {
  id
  minGroupSize
  price
}
    `;
export const ProductTranslationFieldsFragmentDoc = gql`
    fragment ProductTranslationFields on ProductTranslation {
  lang
  name
  headline
  highlights
  included
  notIncluded
  remarks
  meetingPlaceName
  meetingPlaceDescription
  featuredGuideComment
  itinerary
  cancellationPolicy
  ogTitle
  ogDescription
  metaDescription
}
    `;
export const ProductYouTubeFieldsFragmentDoc = gql`
    fragment ProductYouTubeFields on ProductYouTube {
  youtubeId
  title
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  created
  lastUpdated
  duration
  poster
  meetingPlaceGoogleMapsUrl
  defaultMaximumInGroup
  maximumInGroup
  metrics {
    numPeople
  }
  mainImage
  name
  state
  cancellationLimit
  availabilityType
  meetingPlaceGoogleMapsQuery {
    placeId
    geoLocation {
      lat
      lng
    }
  }
}
    `;
export const ReviewFieldsFragmentDoc = gql`
    fragment ReviewFields on Review {
  id
  text
  reviewerName
  reviewDate
  stars
  reviewerImageUrl
  imageUrl
  isApprovedImage
  booking {
    group {
      date
    }
  }
}
    `;
export const TagTranslationFieldsFragmentDoc = gql`
    fragment TagTranslationFields on TagTranslation {
  created
  lastUpdated
  lang
  name
}
    `;
export const TagFieldsFragmentDoc = gql`
    fragment TagFields on Tag {
  id
  created
  lastUpdated
  name
}
    `;
export const ApproveBookingPortalRegistrationRequestDocument = gql`
    mutation ApproveBookingPortalRegistrationRequest($token: ID!) {
  approveBookingPortalRegistrationRequest(token: $token) {
    success
    error
    email
  }
}
    `;
export type ApproveBookingPortalRegistrationRequestMutationFn = Apollo.MutationFunction<ApproveBookingPortalRegistrationRequestMutation, ApproveBookingPortalRegistrationRequestMutationVariables>;

/**
 * __useApproveBookingPortalRegistrationRequestMutation__
 *
 * To run a mutation, you first call `useApproveBookingPortalRegistrationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBookingPortalRegistrationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBookingPortalRegistrationRequestMutation, { data, loading, error }] = useApproveBookingPortalRegistrationRequestMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useApproveBookingPortalRegistrationRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBookingPortalRegistrationRequestMutation, ApproveBookingPortalRegistrationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBookingPortalRegistrationRequestMutation, ApproveBookingPortalRegistrationRequestMutationVariables>(ApproveBookingPortalRegistrationRequestDocument, options);
      }
export type ApproveBookingPortalRegistrationRequestMutationHookResult = ReturnType<typeof useApproveBookingPortalRegistrationRequestMutation>;
export type ApproveBookingPortalRegistrationRequestMutationResult = Apollo.MutationResult<ApproveBookingPortalRegistrationRequestMutation>;
export type ApproveBookingPortalRegistrationRequestMutationOptions = Apollo.BaseMutationOptions<ApproveBookingPortalRegistrationRequestMutation, ApproveBookingPortalRegistrationRequestMutationVariables>;
export const DeleteAllWaitingListsDocument = gql`
    mutation DeleteAllWaitingLists($id: ID!) {
  deleteAllWaitingLists(id: $id) {
    id
  }
}
    `;
export type DeleteAllWaitingListsMutationFn = Apollo.MutationFunction<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>;

/**
 * __useDeleteAllWaitingListsMutation__
 *
 * To run a mutation, you first call `useDeleteAllWaitingListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllWaitingListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllWaitingListsMutation, { data, loading, error }] = useDeleteAllWaitingListsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAllWaitingListsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>(DeleteAllWaitingListsDocument, options);
      }
export type DeleteAllWaitingListsMutationHookResult = ReturnType<typeof useDeleteAllWaitingListsMutation>;
export type DeleteAllWaitingListsMutationResult = Apollo.MutationResult<DeleteAllWaitingListsMutation>;
export type DeleteAllWaitingListsMutationOptions = Apollo.BaseMutationOptions<DeleteAllWaitingListsMutation, DeleteAllWaitingListsMutationVariables>;
export const DeleteWaitingListsDocument = gql`
    mutation DeleteWaitingLists($ids: [ID!]!) {
  deleteWaitingLists(ids: $ids) {
    id
  }
}
    `;
export type DeleteWaitingListsMutationFn = Apollo.MutationFunction<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>;

/**
 * __useDeleteWaitingListsMutation__
 *
 * To run a mutation, you first call `useDeleteWaitingListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWaitingListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWaitingListsMutation, { data, loading, error }] = useDeleteWaitingListsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteWaitingListsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>(DeleteWaitingListsDocument, options);
      }
export type DeleteWaitingListsMutationHookResult = ReturnType<typeof useDeleteWaitingListsMutation>;
export type DeleteWaitingListsMutationResult = Apollo.MutationResult<DeleteWaitingListsMutation>;
export type DeleteWaitingListsMutationOptions = Apollo.BaseMutationOptions<DeleteWaitingListsMutation, DeleteWaitingListsMutationVariables>;
export const EditGuestReviewDocument = gql`
    mutation EditGuestReview($input: GuestReviewInput!) {
  editGuestReview(input: $input) {
    score
    reviewText
  }
}
    `;
export type EditGuestReviewMutationFn = Apollo.MutationFunction<EditGuestReviewMutation, EditGuestReviewMutationVariables>;

/**
 * __useEditGuestReviewMutation__
 *
 * To run a mutation, you first call `useEditGuestReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGuestReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGuestReviewMutation, { data, loading, error }] = useEditGuestReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditGuestReviewMutation(baseOptions?: Apollo.MutationHookOptions<EditGuestReviewMutation, EditGuestReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGuestReviewMutation, EditGuestReviewMutationVariables>(EditGuestReviewDocument, options);
      }
export type EditGuestReviewMutationHookResult = ReturnType<typeof useEditGuestReviewMutation>;
export type EditGuestReviewMutationResult = Apollo.MutationResult<EditGuestReviewMutation>;
export type EditGuestReviewMutationOptions = Apollo.BaseMutationOptions<EditGuestReviewMutation, EditGuestReviewMutationVariables>;
export const EditWaitingListDocument = gql`
    mutation EditWaitingList($input: EditWaitingListInput!) {
  editWaitingList(input: $input) {
    active
    contacted
    fromDate
    groupSize
    id
    productId
    untilDate
  }
}
    `;
export type EditWaitingListMutationFn = Apollo.MutationFunction<EditWaitingListMutation, EditWaitingListMutationVariables>;

/**
 * __useEditWaitingListMutation__
 *
 * To run a mutation, you first call `useEditWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWaitingListMutation, { data, loading, error }] = useEditWaitingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<EditWaitingListMutation, EditWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWaitingListMutation, EditWaitingListMutationVariables>(EditWaitingListDocument, options);
      }
export type EditWaitingListMutationHookResult = ReturnType<typeof useEditWaitingListMutation>;
export type EditWaitingListMutationResult = Apollo.MutationResult<EditWaitingListMutation>;
export type EditWaitingListMutationOptions = Apollo.BaseMutationOptions<EditWaitingListMutation, EditWaitingListMutationVariables>;
export const EditWaitingListUserDocument = gql`
    mutation EditWaitingListUser($input: EditWaitingListUserInput!) {
  editWaitingListUser(input: $input) {
    timeZone
  }
}
    `;
export type EditWaitingListUserMutationFn = Apollo.MutationFunction<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>;

/**
 * __useEditWaitingListUserMutation__
 *
 * To run a mutation, you first call `useEditWaitingListUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWaitingListUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWaitingListUserMutation, { data, loading, error }] = useEditWaitingListUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditWaitingListUserMutation(baseOptions?: Apollo.MutationHookOptions<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>(EditWaitingListUserDocument, options);
      }
export type EditWaitingListUserMutationHookResult = ReturnType<typeof useEditWaitingListUserMutation>;
export type EditWaitingListUserMutationResult = Apollo.MutationResult<EditWaitingListUserMutation>;
export type EditWaitingListUserMutationOptions = Apollo.BaseMutationOptions<EditWaitingListUserMutation, EditWaitingListUserMutationVariables>;
export const EndStorefrontSessionDocument = gql`
    mutation EndStorefrontSession {
  endStorefrontSession
}
    `;
export type EndStorefrontSessionMutationFn = Apollo.MutationFunction<EndStorefrontSessionMutation, EndStorefrontSessionMutationVariables>;

/**
 * __useEndStorefrontSessionMutation__
 *
 * To run a mutation, you first call `useEndStorefrontSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndStorefrontSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endStorefrontSessionMutation, { data, loading, error }] = useEndStorefrontSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndStorefrontSessionMutation(baseOptions?: Apollo.MutationHookOptions<EndStorefrontSessionMutation, EndStorefrontSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndStorefrontSessionMutation, EndStorefrontSessionMutationVariables>(EndStorefrontSessionDocument, options);
      }
export type EndStorefrontSessionMutationHookResult = ReturnType<typeof useEndStorefrontSessionMutation>;
export type EndStorefrontSessionMutationResult = Apollo.MutationResult<EndStorefrontSessionMutation>;
export type EndStorefrontSessionMutationOptions = Apollo.BaseMutationOptions<EndStorefrontSessionMutation, EndStorefrontSessionMutationVariables>;
export const LoginBookingPortalDocument = gql`
    mutation LoginBookingPortal($token: ID!) {
  loginBookingPortal(token: $token) {
    sid
    csrf
  }
}
    `;
export type LoginBookingPortalMutationFn = Apollo.MutationFunction<LoginBookingPortalMutation, LoginBookingPortalMutationVariables>;

/**
 * __useLoginBookingPortalMutation__
 *
 * To run a mutation, you first call `useLoginBookingPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginBookingPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginBookingPortalMutation, { data, loading, error }] = useLoginBookingPortalMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginBookingPortalMutation(baseOptions?: Apollo.MutationHookOptions<LoginBookingPortalMutation, LoginBookingPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginBookingPortalMutation, LoginBookingPortalMutationVariables>(LoginBookingPortalDocument, options);
      }
export type LoginBookingPortalMutationHookResult = ReturnType<typeof useLoginBookingPortalMutation>;
export type LoginBookingPortalMutationResult = Apollo.MutationResult<LoginBookingPortalMutation>;
export type LoginBookingPortalMutationOptions = Apollo.BaseMutationOptions<LoginBookingPortalMutation, LoginBookingPortalMutationVariables>;
export const RegisterBookingPortalGuestDocument = gql`
    mutation RegisterBookingPortalGuest($token: ID!, $guest: RegisterNewGuestInput!) {
  registerBookingPortalGuest(token: $token, guest: $guest) {
    sid
    csrf
  }
}
    `;
export type RegisterBookingPortalGuestMutationFn = Apollo.MutationFunction<RegisterBookingPortalGuestMutation, RegisterBookingPortalGuestMutationVariables>;

/**
 * __useRegisterBookingPortalGuestMutation__
 *
 * To run a mutation, you first call `useRegisterBookingPortalGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBookingPortalGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBookingPortalGuestMutation, { data, loading, error }] = useRegisterBookingPortalGuestMutation({
 *   variables: {
 *      token: // value for 'token'
 *      guest: // value for 'guest'
 *   },
 * });
 */
export function useRegisterBookingPortalGuestMutation(baseOptions?: Apollo.MutationHookOptions<RegisterBookingPortalGuestMutation, RegisterBookingPortalGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterBookingPortalGuestMutation, RegisterBookingPortalGuestMutationVariables>(RegisterBookingPortalGuestDocument, options);
      }
export type RegisterBookingPortalGuestMutationHookResult = ReturnType<typeof useRegisterBookingPortalGuestMutation>;
export type RegisterBookingPortalGuestMutationResult = Apollo.MutationResult<RegisterBookingPortalGuestMutation>;
export type RegisterBookingPortalGuestMutationOptions = Apollo.BaseMutationOptions<RegisterBookingPortalGuestMutation, RegisterBookingPortalGuestMutationVariables>;
export const RemoveBookingPortalGuestDocument = gql`
    mutation RemoveBookingPortalGuest($guestId: ID!) {
  removeBookingPortalGuest(guestId: $guestId)
}
    `;
export type RemoveBookingPortalGuestMutationFn = Apollo.MutationFunction<RemoveBookingPortalGuestMutation, RemoveBookingPortalGuestMutationVariables>;

/**
 * __useRemoveBookingPortalGuestMutation__
 *
 * To run a mutation, you first call `useRemoveBookingPortalGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookingPortalGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookingPortalGuestMutation, { data, loading, error }] = useRemoveBookingPortalGuestMutation({
 *   variables: {
 *      guestId: // value for 'guestId'
 *   },
 * });
 */
export function useRemoveBookingPortalGuestMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookingPortalGuestMutation, RemoveBookingPortalGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookingPortalGuestMutation, RemoveBookingPortalGuestMutationVariables>(RemoveBookingPortalGuestDocument, options);
      }
export type RemoveBookingPortalGuestMutationHookResult = ReturnType<typeof useRemoveBookingPortalGuestMutation>;
export type RemoveBookingPortalGuestMutationResult = Apollo.MutationResult<RemoveBookingPortalGuestMutation>;
export type RemoveBookingPortalGuestMutationOptions = Apollo.BaseMutationOptions<RemoveBookingPortalGuestMutation, RemoveBookingPortalGuestMutationVariables>;
export const ResendBookingPortalPendingInvitationDocument = gql`
    mutation ResendBookingPortalPendingInvitation($invitationId: ID!) {
  resendBookingPortalPendingInvitation(invitationId: $invitationId)
}
    `;
export type ResendBookingPortalPendingInvitationMutationFn = Apollo.MutationFunction<ResendBookingPortalPendingInvitationMutation, ResendBookingPortalPendingInvitationMutationVariables>;

/**
 * __useResendBookingPortalPendingInvitationMutation__
 *
 * To run a mutation, you first call `useResendBookingPortalPendingInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBookingPortalPendingInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBookingPortalPendingInvitationMutation, { data, loading, error }] = useResendBookingPortalPendingInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useResendBookingPortalPendingInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendBookingPortalPendingInvitationMutation, ResendBookingPortalPendingInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendBookingPortalPendingInvitationMutation, ResendBookingPortalPendingInvitationMutationVariables>(ResendBookingPortalPendingInvitationDocument, options);
      }
export type ResendBookingPortalPendingInvitationMutationHookResult = ReturnType<typeof useResendBookingPortalPendingInvitationMutation>;
export type ResendBookingPortalPendingInvitationMutationResult = Apollo.MutationResult<ResendBookingPortalPendingInvitationMutation>;
export type ResendBookingPortalPendingInvitationMutationOptions = Apollo.BaseMutationOptions<ResendBookingPortalPendingInvitationMutation, ResendBookingPortalPendingInvitationMutationVariables>;
export const RevokeBookingPortalPendingInvitationDocument = gql`
    mutation RevokeBookingPortalPendingInvitation($invitationId: ID!) {
  revokeBookingPortalPendingInvitation(invitationId: $invitationId)
}
    `;
export type RevokeBookingPortalPendingInvitationMutationFn = Apollo.MutationFunction<RevokeBookingPortalPendingInvitationMutation, RevokeBookingPortalPendingInvitationMutationVariables>;

/**
 * __useRevokeBookingPortalPendingInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeBookingPortalPendingInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeBookingPortalPendingInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeBookingPortalPendingInvitationMutation, { data, loading, error }] = useRevokeBookingPortalPendingInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRevokeBookingPortalPendingInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeBookingPortalPendingInvitationMutation, RevokeBookingPortalPendingInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeBookingPortalPendingInvitationMutation, RevokeBookingPortalPendingInvitationMutationVariables>(RevokeBookingPortalPendingInvitationDocument, options);
      }
export type RevokeBookingPortalPendingInvitationMutationHookResult = ReturnType<typeof useRevokeBookingPortalPendingInvitationMutation>;
export type RevokeBookingPortalPendingInvitationMutationResult = Apollo.MutationResult<RevokeBookingPortalPendingInvitationMutation>;
export type RevokeBookingPortalPendingInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeBookingPortalPendingInvitationMutation, RevokeBookingPortalPendingInvitationMutationVariables>;
export const RevokeCheckoutBookingPortalInvitationDocument = gql`
    mutation RevokeCheckoutBookingPortalInvitation($invitationId: ID!) {
  revokeCheckoutBookingPortalInvitation(invitationId: $invitationId)
}
    `;
export type RevokeCheckoutBookingPortalInvitationMutationFn = Apollo.MutationFunction<RevokeCheckoutBookingPortalInvitationMutation, RevokeCheckoutBookingPortalInvitationMutationVariables>;

/**
 * __useRevokeCheckoutBookingPortalInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeCheckoutBookingPortalInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCheckoutBookingPortalInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCheckoutBookingPortalInvitationMutation, { data, loading, error }] = useRevokeCheckoutBookingPortalInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRevokeCheckoutBookingPortalInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCheckoutBookingPortalInvitationMutation, RevokeCheckoutBookingPortalInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCheckoutBookingPortalInvitationMutation, RevokeCheckoutBookingPortalInvitationMutationVariables>(RevokeCheckoutBookingPortalInvitationDocument, options);
      }
export type RevokeCheckoutBookingPortalInvitationMutationHookResult = ReturnType<typeof useRevokeCheckoutBookingPortalInvitationMutation>;
export type RevokeCheckoutBookingPortalInvitationMutationResult = Apollo.MutationResult<RevokeCheckoutBookingPortalInvitationMutation>;
export type RevokeCheckoutBookingPortalInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeCheckoutBookingPortalInvitationMutation, RevokeCheckoutBookingPortalInvitationMutationVariables>;
export const SendBookingPortalInvitationDocument = gql`
    mutation SendBookingPortalInvitation($bookingId: ID!, $email: String!, $guestId: ID, $givenName: String, $familyName: String, $phoneNumber: String) {
  sendBookingPortalInvitation(
    bookingId: $bookingId
    email: $email
    guestId: $guestId
    givenName: $givenName
    familyName: $familyName
    phoneNumber: $phoneNumber
  ) {
    id
  }
}
    `;
export type SendBookingPortalInvitationMutationFn = Apollo.MutationFunction<SendBookingPortalInvitationMutation, SendBookingPortalInvitationMutationVariables>;

/**
 * __useSendBookingPortalInvitationMutation__
 *
 * To run a mutation, you first call `useSendBookingPortalInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingPortalInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingPortalInvitationMutation, { data, loading, error }] = useSendBookingPortalInvitationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      email: // value for 'email'
 *      guestId: // value for 'guestId'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSendBookingPortalInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendBookingPortalInvitationMutation, SendBookingPortalInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBookingPortalInvitationMutation, SendBookingPortalInvitationMutationVariables>(SendBookingPortalInvitationDocument, options);
      }
export type SendBookingPortalInvitationMutationHookResult = ReturnType<typeof useSendBookingPortalInvitationMutation>;
export type SendBookingPortalInvitationMutationResult = Apollo.MutationResult<SendBookingPortalInvitationMutation>;
export type SendBookingPortalInvitationMutationOptions = Apollo.BaseMutationOptions<SendBookingPortalInvitationMutation, SendBookingPortalInvitationMutationVariables>;
export const SendBookingPortalLoginTokenDocument = gql`
    mutation SendBookingPortalLoginToken($guestId: ID, $guestEmail: String, $allTrips: Boolean, $tab: BookingPortalTab, $rating: Int, $requestedFrom: BookingPortalLoginRequestedFrom!) {
  sendBookingPortalLoginToken(
    guestId: $guestId
    guestEmail: $guestEmail
    allTrips: $allTrips
    tab: $tab
    rating: $rating
    requestedFrom: $requestedFrom
  )
}
    `;
export type SendBookingPortalLoginTokenMutationFn = Apollo.MutationFunction<SendBookingPortalLoginTokenMutation, SendBookingPortalLoginTokenMutationVariables>;

/**
 * __useSendBookingPortalLoginTokenMutation__
 *
 * To run a mutation, you first call `useSendBookingPortalLoginTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingPortalLoginTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingPortalLoginTokenMutation, { data, loading, error }] = useSendBookingPortalLoginTokenMutation({
 *   variables: {
 *      guestId: // value for 'guestId'
 *      guestEmail: // value for 'guestEmail'
 *      allTrips: // value for 'allTrips'
 *      tab: // value for 'tab'
 *      rating: // value for 'rating'
 *      requestedFrom: // value for 'requestedFrom'
 *   },
 * });
 */
export function useSendBookingPortalLoginTokenMutation(baseOptions?: Apollo.MutationHookOptions<SendBookingPortalLoginTokenMutation, SendBookingPortalLoginTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBookingPortalLoginTokenMutation, SendBookingPortalLoginTokenMutationVariables>(SendBookingPortalLoginTokenDocument, options);
      }
export type SendBookingPortalLoginTokenMutationHookResult = ReturnType<typeof useSendBookingPortalLoginTokenMutation>;
export type SendBookingPortalLoginTokenMutationResult = Apollo.MutationResult<SendBookingPortalLoginTokenMutation>;
export type SendBookingPortalLoginTokenMutationOptions = Apollo.BaseMutationOptions<SendBookingPortalLoginTokenMutation, SendBookingPortalLoginTokenMutationVariables>;
export const SendBookingPortalRegistrationRequestDocument = gql`
    mutation SendBookingPortalRegistrationRequest($bookingId: ID!, $email: String!) {
  sendBookingPortalRegistrationRequest(bookingId: $bookingId, email: $email)
}
    `;
export type SendBookingPortalRegistrationRequestMutationFn = Apollo.MutationFunction<SendBookingPortalRegistrationRequestMutation, SendBookingPortalRegistrationRequestMutationVariables>;

/**
 * __useSendBookingPortalRegistrationRequestMutation__
 *
 * To run a mutation, you first call `useSendBookingPortalRegistrationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingPortalRegistrationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingPortalRegistrationRequestMutation, { data, loading, error }] = useSendBookingPortalRegistrationRequestMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendBookingPortalRegistrationRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendBookingPortalRegistrationRequestMutation, SendBookingPortalRegistrationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBookingPortalRegistrationRequestMutation, SendBookingPortalRegistrationRequestMutationVariables>(SendBookingPortalRegistrationRequestDocument, options);
      }
export type SendBookingPortalRegistrationRequestMutationHookResult = ReturnType<typeof useSendBookingPortalRegistrationRequestMutation>;
export type SendBookingPortalRegistrationRequestMutationResult = Apollo.MutationResult<SendBookingPortalRegistrationRequestMutation>;
export type SendBookingPortalRegistrationRequestMutationOptions = Apollo.BaseMutationOptions<SendBookingPortalRegistrationRequestMutation, SendBookingPortalRegistrationRequestMutationVariables>;
export const SendChatMessageDocument = gql`
    mutation sendChatMessage($input: SendChatMessageInput!) {
  sendChatMessage(input: $input) {
    ...ChatMessageFields
    media {
      ...ChatMessageMediaFields
    }
  }
}
    ${ChatMessageFieldsFragmentDoc}
${ChatMessageMediaFieldsFragmentDoc}`;
export type SendChatMessageMutationFn = Apollo.MutationFunction<SendChatMessageMutation, SendChatMessageMutationVariables>;

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = useSendChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMessageMutation, SendChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMessageMutation, SendChatMessageMutationVariables>(SendChatMessageDocument, options);
      }
export type SendChatMessageMutationHookResult = ReturnType<typeof useSendChatMessageMutation>;
export type SendChatMessageMutationResult = Apollo.MutationResult<SendChatMessageMutation>;
export type SendChatMessageMutationOptions = Apollo.BaseMutationOptions<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const SendCheckoutBookingPortalInvitationDocument = gql`
    mutation SendCheckoutBookingPortalInvitation($bookingId: ID!, $email: String!, $guestId: ID, $givenName: String, $familyName: String, $phoneNumber: String) {
  sendCheckoutBookingPortalInvitation(
    bookingId: $bookingId
    email: $email
    guestId: $guestId
    givenName: $givenName
    familyName: $familyName
    phoneNumber: $phoneNumber
  ) {
    id
    bookingId
    guestId
    email
    givenName
    familyName
    created
  }
}
    `;
export type SendCheckoutBookingPortalInvitationMutationFn = Apollo.MutationFunction<SendCheckoutBookingPortalInvitationMutation, SendCheckoutBookingPortalInvitationMutationVariables>;

/**
 * __useSendCheckoutBookingPortalInvitationMutation__
 *
 * To run a mutation, you first call `useSendCheckoutBookingPortalInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCheckoutBookingPortalInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCheckoutBookingPortalInvitationMutation, { data, loading, error }] = useSendCheckoutBookingPortalInvitationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      email: // value for 'email'
 *      guestId: // value for 'guestId'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSendCheckoutBookingPortalInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendCheckoutBookingPortalInvitationMutation, SendCheckoutBookingPortalInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCheckoutBookingPortalInvitationMutation, SendCheckoutBookingPortalInvitationMutationVariables>(SendCheckoutBookingPortalInvitationDocument, options);
      }
export type SendCheckoutBookingPortalInvitationMutationHookResult = ReturnType<typeof useSendCheckoutBookingPortalInvitationMutation>;
export type SendCheckoutBookingPortalInvitationMutationResult = Apollo.MutationResult<SendCheckoutBookingPortalInvitationMutation>;
export type SendCheckoutBookingPortalInvitationMutationOptions = Apollo.BaseMutationOptions<SendCheckoutBookingPortalInvitationMutation, SendCheckoutBookingPortalInvitationMutationVariables>;
export const SetReviewLocationDocument = gql`
    mutation SetReviewLocation($input: SetReviewLocationInput!) {
  setReviewLocation(input: $input) {
    reviewSource
    reviewSourceUrl
  }
}
    `;
export type SetReviewLocationMutationFn = Apollo.MutationFunction<SetReviewLocationMutation, SetReviewLocationMutationVariables>;

/**
 * __useSetReviewLocationMutation__
 *
 * To run a mutation, you first call `useSetReviewLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReviewLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReviewLocationMutation, { data, loading, error }] = useSetReviewLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetReviewLocationMutation(baseOptions?: Apollo.MutationHookOptions<SetReviewLocationMutation, SetReviewLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReviewLocationMutation, SetReviewLocationMutationVariables>(SetReviewLocationDocument, options);
      }
export type SetReviewLocationMutationHookResult = ReturnType<typeof useSetReviewLocationMutation>;
export type SetReviewLocationMutationResult = Apollo.MutationResult<SetReviewLocationMutation>;
export type SetReviewLocationMutationOptions = Apollo.BaseMutationOptions<SetReviewLocationMutation, SetReviewLocationMutationVariables>;
export const SignContractsDocument = gql`
    mutation signContracts($guideId: ID!, $signature: String!) {
  signContracts(guideId: $guideId, signature: $signature)
}
    `;
export type SignContractsMutationFn = Apollo.MutationFunction<SignContractsMutation, SignContractsMutationVariables>;

/**
 * __useSignContractsMutation__
 *
 * To run a mutation, you first call `useSignContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signContractsMutation, { data, loading, error }] = useSignContractsMutation({
 *   variables: {
 *      guideId: // value for 'guideId'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useSignContractsMutation(baseOptions?: Apollo.MutationHookOptions<SignContractsMutation, SignContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignContractsMutation, SignContractsMutationVariables>(SignContractsDocument, options);
      }
export type SignContractsMutationHookResult = ReturnType<typeof useSignContractsMutation>;
export type SignContractsMutationResult = Apollo.MutationResult<SignContractsMutation>;
export type SignContractsMutationOptions = Apollo.BaseMutationOptions<SignContractsMutation, SignContractsMutationVariables>;
export const StartCheckoutBookingPortalSessionDocument = gql`
    mutation StartCheckoutBookingPortalSession($bookingId: ID!) {
  startCheckoutBookingPortalSession(bookingId: $bookingId) {
    sid
  }
}
    `;
export type StartCheckoutBookingPortalSessionMutationFn = Apollo.MutationFunction<StartCheckoutBookingPortalSessionMutation, StartCheckoutBookingPortalSessionMutationVariables>;

/**
 * __useStartCheckoutBookingPortalSessionMutation__
 *
 * To run a mutation, you first call `useStartCheckoutBookingPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCheckoutBookingPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCheckoutBookingPortalSessionMutation, { data, loading, error }] = useStartCheckoutBookingPortalSessionMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useStartCheckoutBookingPortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartCheckoutBookingPortalSessionMutation, StartCheckoutBookingPortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCheckoutBookingPortalSessionMutation, StartCheckoutBookingPortalSessionMutationVariables>(StartCheckoutBookingPortalSessionDocument, options);
      }
export type StartCheckoutBookingPortalSessionMutationHookResult = ReturnType<typeof useStartCheckoutBookingPortalSessionMutation>;
export type StartCheckoutBookingPortalSessionMutationResult = Apollo.MutationResult<StartCheckoutBookingPortalSessionMutation>;
export type StartCheckoutBookingPortalSessionMutationOptions = Apollo.BaseMutationOptions<StartCheckoutBookingPortalSessionMutation, StartCheckoutBookingPortalSessionMutationVariables>;
export const ToggleWaitingListDocument = gql`
    mutation ToggleWaitingList($id: ID!) {
  toggleWaitingList(id: $id)
}
    `;
export type ToggleWaitingListMutationFn = Apollo.MutationFunction<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>;

/**
 * __useToggleWaitingListMutation__
 *
 * To run a mutation, you first call `useToggleWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWaitingListMutation, { data, loading, error }] = useToggleWaitingListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>(ToggleWaitingListDocument, options);
      }
export type ToggleWaitingListMutationHookResult = ReturnType<typeof useToggleWaitingListMutation>;
export type ToggleWaitingListMutationResult = Apollo.MutationResult<ToggleWaitingListMutation>;
export type ToggleWaitingListMutationOptions = Apollo.BaseMutationOptions<ToggleWaitingListMutation, ToggleWaitingListMutationVariables>;
export const UpdateBookingPortalPendingInvitationDocument = gql`
    mutation UpdateBookingPortalPendingInvitation($input: UpdateBookingPortalPendingInvitationInput!) {
  updateBookingPortalPendingInvitation(input: $input)
}
    `;
export type UpdateBookingPortalPendingInvitationMutationFn = Apollo.MutationFunction<UpdateBookingPortalPendingInvitationMutation, UpdateBookingPortalPendingInvitationMutationVariables>;

/**
 * __useUpdateBookingPortalPendingInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateBookingPortalPendingInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingPortalPendingInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingPortalPendingInvitationMutation, { data, loading, error }] = useUpdateBookingPortalPendingInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingPortalPendingInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingPortalPendingInvitationMutation, UpdateBookingPortalPendingInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingPortalPendingInvitationMutation, UpdateBookingPortalPendingInvitationMutationVariables>(UpdateBookingPortalPendingInvitationDocument, options);
      }
export type UpdateBookingPortalPendingInvitationMutationHookResult = ReturnType<typeof useUpdateBookingPortalPendingInvitationMutation>;
export type UpdateBookingPortalPendingInvitationMutationResult = Apollo.MutationResult<UpdateBookingPortalPendingInvitationMutation>;
export type UpdateBookingPortalPendingInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateBookingPortalPendingInvitationMutation, UpdateBookingPortalPendingInvitationMutationVariables>;
export const UpdateCurrentBookingPortalGuestDocument = gql`
    mutation UpdateCurrentBookingPortalGuest($input: UpdateCurrentBookingPortalGuestInput!) {
  updateCurrentBookingPortalGuest(input: $input)
}
    `;
export type UpdateCurrentBookingPortalGuestMutationFn = Apollo.MutationFunction<UpdateCurrentBookingPortalGuestMutation, UpdateCurrentBookingPortalGuestMutationVariables>;

/**
 * __useUpdateCurrentBookingPortalGuestMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentBookingPortalGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentBookingPortalGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentBookingPortalGuestMutation, { data, loading, error }] = useUpdateCurrentBookingPortalGuestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentBookingPortalGuestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentBookingPortalGuestMutation, UpdateCurrentBookingPortalGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentBookingPortalGuestMutation, UpdateCurrentBookingPortalGuestMutationVariables>(UpdateCurrentBookingPortalGuestDocument, options);
      }
export type UpdateCurrentBookingPortalGuestMutationHookResult = ReturnType<typeof useUpdateCurrentBookingPortalGuestMutation>;
export type UpdateCurrentBookingPortalGuestMutationResult = Apollo.MutationResult<UpdateCurrentBookingPortalGuestMutation>;
export type UpdateCurrentBookingPortalGuestMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentBookingPortalGuestMutation, UpdateCurrentBookingPortalGuestMutationVariables>;
export const GetAllCountriesDocument = gql`
    query getAllCountries($input: LocationsInput) {
  locations(input: $input) {
    records {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
      }
export function useGetAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export type GetAllCountriesQueryHookResult = ReturnType<typeof useGetAllCountriesQuery>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<typeof useGetAllCountriesLazyQuery>;
export type GetAllCountriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCountriesSuspenseQuery>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const GetAllLocationIdsDocument = gql`
    query getAllLocationIds {
  locations {
    records {
      id
      slug
      country {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllLocationIdsQuery__
 *
 * To run a query within a React component, call `useGetAllLocationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>(GetAllLocationIdsDocument, options);
      }
export function useGetAllLocationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>(GetAllLocationIdsDocument, options);
        }
export function useGetAllLocationIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>(GetAllLocationIdsDocument, options);
        }
export type GetAllLocationIdsQueryHookResult = ReturnType<typeof useGetAllLocationIdsQuery>;
export type GetAllLocationIdsLazyQueryHookResult = ReturnType<typeof useGetAllLocationIdsLazyQuery>;
export type GetAllLocationIdsSuspenseQueryHookResult = ReturnType<typeof useGetAllLocationIdsSuspenseQuery>;
export type GetAllLocationIdsQueryResult = Apollo.QueryResult<GetAllLocationIdsQuery, GetAllLocationIdsQueryVariables>;
export const GetAllProductCollectionSlugsDocument = gql`
    query getAllProductCollectionSlugs {
  productCollections(input: {hasPage: true}) {
    totalRecords
    records {
      slug
    }
  }
}
    `;

/**
 * __useGetAllProductCollectionSlugsQuery__
 *
 * To run a query within a React component, call `useGetAllProductCollectionSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductCollectionSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductCollectionSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductCollectionSlugsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>(GetAllProductCollectionSlugsDocument, options);
      }
export function useGetAllProductCollectionSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>(GetAllProductCollectionSlugsDocument, options);
        }
export function useGetAllProductCollectionSlugsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>(GetAllProductCollectionSlugsDocument, options);
        }
export type GetAllProductCollectionSlugsQueryHookResult = ReturnType<typeof useGetAllProductCollectionSlugsQuery>;
export type GetAllProductCollectionSlugsLazyQueryHookResult = ReturnType<typeof useGetAllProductCollectionSlugsLazyQuery>;
export type GetAllProductCollectionSlugsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductCollectionSlugsSuspenseQuery>;
export type GetAllProductCollectionSlugsQueryResult = Apollo.QueryResult<GetAllProductCollectionSlugsQuery, GetAllProductCollectionSlugsQueryVariables>;
export const GetAllProductOptionsDocument = gql`
    query getAllProductOptions {
  productOptions {
    records {
      id
      translation {
        name
      }
      location {
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllProductOptionsQuery__
 *
 * To run a query within a React component, call `useGetAllProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>(GetAllProductOptionsDocument, options);
      }
export function useGetAllProductOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>(GetAllProductOptionsDocument, options);
        }
export function useGetAllProductOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>(GetAllProductOptionsDocument, options);
        }
export type GetAllProductOptionsQueryHookResult = ReturnType<typeof useGetAllProductOptionsQuery>;
export type GetAllProductOptionsLazyQueryHookResult = ReturnType<typeof useGetAllProductOptionsLazyQuery>;
export type GetAllProductOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductOptionsSuspenseQuery>;
export type GetAllProductOptionsQueryResult = Apollo.QueryResult<GetAllProductOptionsQuery, GetAllProductOptionsQueryVariables>;
export const GetAvailableGuidesDocument = gql`
    query getAvailableGuides($productId: ID!, $lang: Iso639!, $fromDate: Date!, $untilDate: Date!) {
  product(input: {id: $productId}) {
    id
    availability(fromDate: $fromDate, untilDate: $untilDate) {
      ...ProductAvailabilityFields
      timeSlots {
        ...ProductAvailabilityTimeFields
        groups {
          ...ProductAvailabilityGroupFields
          guides {
            ...GuideFields
            translation(lang: $lang) {
              ...GuideTranslationFields
            }
            reviewSummary {
              average
              numReviews
            }
          }
        }
      }
    }
  }
}
    ${ProductAvailabilityFieldsFragmentDoc}
${ProductAvailabilityTimeFieldsFragmentDoc}
${ProductAvailabilityGroupFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${GuideTranslationFieldsFragmentDoc}`;

/**
 * __useGetAvailableGuidesQuery__
 *
 * To run a query within a React component, call `useGetAvailableGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableGuidesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      lang: // value for 'lang'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetAvailableGuidesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables> & ({ variables: GetAvailableGuidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>(GetAvailableGuidesDocument, options);
      }
export function useGetAvailableGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>(GetAvailableGuidesDocument, options);
        }
export function useGetAvailableGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>(GetAvailableGuidesDocument, options);
        }
export type GetAvailableGuidesQueryHookResult = ReturnType<typeof useGetAvailableGuidesQuery>;
export type GetAvailableGuidesLazyQueryHookResult = ReturnType<typeof useGetAvailableGuidesLazyQuery>;
export type GetAvailableGuidesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableGuidesSuspenseQuery>;
export type GetAvailableGuidesQueryResult = Apollo.QueryResult<GetAvailableGuidesQuery, GetAvailableGuidesQueryVariables>;
export const GetBookingDocument = gql`
    query getBooking($bookingId: ID!) {
  booking(id: $bookingId) {
    id
    state
    paymentAmount
    currency
    email
    familyName
    givenName
    numPeople
    phoneNumber
    isPrivate
    paidAmount {
      state
      amount
      currency
    }
    payments {
      id
      state
      amount
      currency
      description
    }
    created
    bookingSourceId
    source {
      name
    }
    pickupLocation {
      query {
        placeId
        geoLocation {
          lat
          lng
        }
      }
      name
      address
    }
    guests {
      id
      index
      isLeadGuest
      givenName
      familyName
      email
      phoneNumber
    }
    group {
      date
      time
      hasEnded
      customGroupItinerary {
        id
        stepDescription
        stepOrder
      }
      guideAssignments {
        role
        guide {
          id
          nickName
          profilePic
        }
      }
      media {
        url
        type
      }
      product {
        id
        duration
        isCustomTour
        requiresTransportAgreement
        minimumInGroup
        tripadvisorReviewUrl
        googleMapsReviewUrl
        reviewLocations {
          label
          url
        }
        meetingPlaceGoogleMapsUrl
        meetingPlaceGoogleMapsQuery {
          placeId
          geoLocation {
            lat
            lng
          }
        }
        poster
        faqs {
          id
          question
          answer
          index
        }
        tags {
          id
          name
          translation(lang: en) {
            name
          }
        }
        translation(lang: en) {
          name
          headline
          itinerary
          meetingPlaceDescription
          meetingPlaceName
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingQuery, GetBookingQueryVariables> & ({ variables: GetBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
      }
export function useGetBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export function useGetBookingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export type GetBookingQueryHookResult = ReturnType<typeof useGetBookingQuery>;
export type GetBookingLazyQueryHookResult = ReturnType<typeof useGetBookingLazyQuery>;
export type GetBookingSuspenseQueryHookResult = ReturnType<typeof useGetBookingSuspenseQuery>;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const GetBookingCheckoutDocument = gql`
    query getBookingCheckout($id: ID!, $languageCode: Iso639!, $currencyCode: Currency!) {
  booking(id: $id) {
    id
    state
    created
    isPrivate
    email
    phoneNumber
    couponCode
    numConfirmedBookings
    bookingSourceId
    reviewRating
    paidAmount {
      state
      amount
      currency
    }
    payments {
      id
      state
      amount
      currency
      description
    }
    pickupLocation {
      query {
        placeId
        geoLocation {
          lat
          lng
        }
      }
      name
      address
    }
    coupon {
      amount(currency: $currencyCode)
      code
      type
    }
    paymentAmount(currency: $currencyCode)
    currency
    details {
      productPrice {
        excludeFromPrivateGroupCount
        minAge
        maxAge
        tags
        amount
        id
        currency
      }
      quantity
      unitAmount(currency: $currencyCode)
    }
    group {
      id
      date
      time
      isPrivate
      customGroupItinerary {
        id
        stepDescription
        stepOrder
      }
      product {
        id
        requiresTransportAgreement
        isCustomTour
        minimumInGroup
        hasDefaultVehiclePickup
        hasAccomodationVehiclePickup
        meetingPlaceGoogleMapsUrl
        availabilityType
        cancellationLimit
        currency
        defaultMaximumInGroup
        reviewSummary {
          average
          numReviews
        }
        location {
          countryId
          translation(lang: $languageCode) {
            name
          }
        }
        translation(lang: $languageCode) {
          name
          itinerary
          meetingPlaceDescription
          meetingPlaceName
        }
        poster
        prices(currency: $currencyCode) {
          id
          amount
          currency
          minAge
          maxAge
          tags
          translation(lang: $languageCode) {
            description
          }
        }
        privatePrices(currency: $currencyCode) {
          id
          minGroupSize
          price
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingCheckoutQuery__
 *
 * To run a query within a React component, call `useGetBookingCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *      currencyCode: // value for 'currencyCode'
 *   },
 * });
 */
export function useGetBookingCheckoutQuery(baseOptions: Apollo.QueryHookOptions<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables> & ({ variables: GetBookingCheckoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables>(GetBookingCheckoutDocument, options);
      }
export function useGetBookingCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables>(GetBookingCheckoutDocument, options);
        }
export function useGetBookingCheckoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables>(GetBookingCheckoutDocument, options);
        }
export type GetBookingCheckoutQueryHookResult = ReturnType<typeof useGetBookingCheckoutQuery>;
export type GetBookingCheckoutLazyQueryHookResult = ReturnType<typeof useGetBookingCheckoutLazyQuery>;
export type GetBookingCheckoutSuspenseQueryHookResult = ReturnType<typeof useGetBookingCheckoutSuspenseQuery>;
export type GetBookingCheckoutQueryResult = Apollo.QueryResult<GetBookingCheckoutQuery, GetBookingCheckoutQueryVariables>;
export const GetBookingDetailsDocument = gql`
    query getBookingDetails($bookingId: ID!, $currency: Currency!) {
  booking(id: $bookingId) {
    details {
      quantity
      unitAmount(currency: $currency)
      productPrice {
        excludeFromPrivateGroupCount
        minAge
        maxAge
        tags
      }
    }
  }
}
    `;

/**
 * __useGetBookingDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingDetailsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetBookingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingDetailsQuery, GetBookingDetailsQueryVariables> & ({ variables: GetBookingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>(GetBookingDetailsDocument, options);
      }
export function useGetBookingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>(GetBookingDetailsDocument, options);
        }
export function useGetBookingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>(GetBookingDetailsDocument, options);
        }
export type GetBookingDetailsQueryHookResult = ReturnType<typeof useGetBookingDetailsQuery>;
export type GetBookingDetailsLazyQueryHookResult = ReturnType<typeof useGetBookingDetailsLazyQuery>;
export type GetBookingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBookingDetailsSuspenseQuery>;
export type GetBookingDetailsQueryResult = Apollo.QueryResult<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>;
export const GetBookingPortalGuestsDocument = gql`
    query GetBookingPortalGuests($bookingId: ID!) {
  booking(id: $bookingId) {
    id
    numPeople
    openInvitationCount
    group {
      id
      date
      product {
        id
        name
        poster
      }
    }
    guests {
      index
      isLeadGuest
      id
      givenName
      maskedEmail
    }
  }
}
    `;

/**
 * __useGetBookingPortalGuestsQuery__
 *
 * To run a query within a React component, call `useGetBookingPortalGuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPortalGuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPortalGuestsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingPortalGuestsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables> & ({ variables: GetBookingPortalGuestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables>(GetBookingPortalGuestsDocument, options);
      }
export function useGetBookingPortalGuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables>(GetBookingPortalGuestsDocument, options);
        }
export function useGetBookingPortalGuestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables>(GetBookingPortalGuestsDocument, options);
        }
export type GetBookingPortalGuestsQueryHookResult = ReturnType<typeof useGetBookingPortalGuestsQuery>;
export type GetBookingPortalGuestsLazyQueryHookResult = ReturnType<typeof useGetBookingPortalGuestsLazyQuery>;
export type GetBookingPortalGuestsSuspenseQueryHookResult = ReturnType<typeof useGetBookingPortalGuestsSuspenseQuery>;
export type GetBookingPortalGuestsQueryResult = Apollo.QueryResult<GetBookingPortalGuestsQuery, GetBookingPortalGuestsQueryVariables>;
export const GetBookingPortalLoginTokenStatusDocument = gql`
    query GetBookingPortalLoginTokenStatus($token: ID!) {
  bookingPortalLoginTokenStatus(token: $token) {
    state
    guestId
    guestGivenName
    guestMaskedEmail
    bookingId
    tourName
    tourDate
    tourPoster
  }
}
    `;

/**
 * __useGetBookingPortalLoginTokenStatusQuery__
 *
 * To run a query within a React component, call `useGetBookingPortalLoginTokenStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPortalLoginTokenStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPortalLoginTokenStatusQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBookingPortalLoginTokenStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables> & ({ variables: GetBookingPortalLoginTokenStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables>(GetBookingPortalLoginTokenStatusDocument, options);
      }
export function useGetBookingPortalLoginTokenStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables>(GetBookingPortalLoginTokenStatusDocument, options);
        }
export function useGetBookingPortalLoginTokenStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables>(GetBookingPortalLoginTokenStatusDocument, options);
        }
export type GetBookingPortalLoginTokenStatusQueryHookResult = ReturnType<typeof useGetBookingPortalLoginTokenStatusQuery>;
export type GetBookingPortalLoginTokenStatusLazyQueryHookResult = ReturnType<typeof useGetBookingPortalLoginTokenStatusLazyQuery>;
export type GetBookingPortalLoginTokenStatusSuspenseQueryHookResult = ReturnType<typeof useGetBookingPortalLoginTokenStatusSuspenseQuery>;
export type GetBookingPortalLoginTokenStatusQueryResult = Apollo.QueryResult<GetBookingPortalLoginTokenStatusQuery, GetBookingPortalLoginTokenStatusQueryVariables>;
export const GetBookingPortalPendingInvitationsDocument = gql`
    query GetBookingPortalPendingInvitations($bookingId: ID!) {
  bookingPortalPendingInvitations(bookingId: $bookingId) {
    id
    bookingId
    guestId
    created
    email
    givenName
    familyName
    phoneNumber
  }
}
    `;

/**
 * __useGetBookingPortalPendingInvitationsQuery__
 *
 * To run a query within a React component, call `useGetBookingPortalPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPortalPendingInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPortalPendingInvitationsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingPortalPendingInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables> & ({ variables: GetBookingPortalPendingInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables>(GetBookingPortalPendingInvitationsDocument, options);
      }
export function useGetBookingPortalPendingInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables>(GetBookingPortalPendingInvitationsDocument, options);
        }
export function useGetBookingPortalPendingInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables>(GetBookingPortalPendingInvitationsDocument, options);
        }
export type GetBookingPortalPendingInvitationsQueryHookResult = ReturnType<typeof useGetBookingPortalPendingInvitationsQuery>;
export type GetBookingPortalPendingInvitationsLazyQueryHookResult = ReturnType<typeof useGetBookingPortalPendingInvitationsLazyQuery>;
export type GetBookingPortalPendingInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetBookingPortalPendingInvitationsSuspenseQuery>;
export type GetBookingPortalPendingInvitationsQueryResult = Apollo.QueryResult<GetBookingPortalPendingInvitationsQuery, GetBookingPortalPendingInvitationsQueryVariables>;
export const GetBookingPortalRegistrationRequestDocument = gql`
    query GetBookingPortalRegistrationRequest($token: ID!) {
  bookingPortalRegistrationRequest(token: $token) {
    bookingId
    email
    familyName
    givenName
    id
    phoneNumber
    token
    approvedAt
    guest {
      id
      givenName
      familyName
    }
    booking {
      id
      group {
        date
        id
        time
        product {
          id
          name
          poster
        }
      }
      leadGuest {
        familyName
        givenName
      }
    }
  }
}
    `;

/**
 * __useGetBookingPortalRegistrationRequestQuery__
 *
 * To run a query within a React component, call `useGetBookingPortalRegistrationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPortalRegistrationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPortalRegistrationRequestQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBookingPortalRegistrationRequestQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables> & ({ variables: GetBookingPortalRegistrationRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables>(GetBookingPortalRegistrationRequestDocument, options);
      }
export function useGetBookingPortalRegistrationRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables>(GetBookingPortalRegistrationRequestDocument, options);
        }
export function useGetBookingPortalRegistrationRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables>(GetBookingPortalRegistrationRequestDocument, options);
        }
export type GetBookingPortalRegistrationRequestQueryHookResult = ReturnType<typeof useGetBookingPortalRegistrationRequestQuery>;
export type GetBookingPortalRegistrationRequestLazyQueryHookResult = ReturnType<typeof useGetBookingPortalRegistrationRequestLazyQuery>;
export type GetBookingPortalRegistrationRequestSuspenseQueryHookResult = ReturnType<typeof useGetBookingPortalRegistrationRequestSuspenseQuery>;
export type GetBookingPortalRegistrationRequestQueryResult = Apollo.QueryResult<GetBookingPortalRegistrationRequestQuery, GetBookingPortalRegistrationRequestQueryVariables>;
export const GetBookingWithChatRoomDocument = gql`
    query getBookingWithChatRoom($bookingId: ID!) {
  booking(id: $bookingId) {
    id
    state
    paymentAmount
    currency
    email
    isPrivate
    created
    leadGuest {
      givenName
      familyName
    }
    pickupLocation {
      query {
        placeId
        geoLocation {
          lat
          lng
        }
      }
      name
      address
    }
    chatRoom {
      ...ChatRoomFields
    }
    group {
      date
      time
      customGroupItinerary {
        id
        stepDescription
        stepOrder
      }
      guideAssignments {
        role
        guide {
          id
          nickName
          profilePic
        }
      }
      product {
        minimumInGroup
        meetingPlaceGoogleMapsUrl
        meetingPlaceGoogleMapsQuery {
          placeId
          geoLocation {
            lat
            lng
          }
        }
        poster
        translation(lang: en) {
          name
          itinerary
          meetingPlaceDescription
          meetingPlaceName
        }
      }
    }
  }
}
    ${ChatRoomFieldsFragmentDoc}`;

/**
 * __useGetBookingWithChatRoomQuery__
 *
 * To run a query within a React component, call `useGetBookingWithChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingWithChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingWithChatRoomQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingWithChatRoomQuery(baseOptions: Apollo.QueryHookOptions<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables> & ({ variables: GetBookingWithChatRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>(GetBookingWithChatRoomDocument, options);
      }
export function useGetBookingWithChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>(GetBookingWithChatRoomDocument, options);
        }
export function useGetBookingWithChatRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>(GetBookingWithChatRoomDocument, options);
        }
export type GetBookingWithChatRoomQueryHookResult = ReturnType<typeof useGetBookingWithChatRoomQuery>;
export type GetBookingWithChatRoomLazyQueryHookResult = ReturnType<typeof useGetBookingWithChatRoomLazyQuery>;
export type GetBookingWithChatRoomSuspenseQueryHookResult = ReturnType<typeof useGetBookingWithChatRoomSuspenseQuery>;
export type GetBookingWithChatRoomQueryResult = Apollo.QueryResult<GetBookingWithChatRoomQuery, GetBookingWithChatRoomQueryVariables>;
export const GetChatMessagesDocument = gql`
    query getChatMessages($bookingId: ID!, $limit: Int, $prevId: String, $nextId: String) {
  chatMessages(
    bookingId: $bookingId
    limit: $limit
    prevId: $prevId
    nextId: $nextId
  ) {
    messages {
      ...ChatMessageFields
      booking {
        ...BookingFields
        leadGuest {
          givenName
          familyName
        }
      }
      guide {
        ...GuideFields
      }
      media {
        ...ChatMessageMediaFields
      }
    }
    totalCount
    hasMore
  }
}
    ${ChatMessageFieldsFragmentDoc}
${BookingFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${ChatMessageMediaFieldsFragmentDoc}`;

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      limit: // value for 'limit'
 *      prevId: // value for 'prevId'
 *      nextId: // value for 'nextId'
 *   },
 * });
 */
export function useGetChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables> & ({ variables: GetChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
      }
export function useGetChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export function useGetChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesSuspenseQuery>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const GetCheckoutBookingPortalInvitationsDocument = gql`
    query GetCheckoutBookingPortalInvitations($bookingId: ID!) {
  checkoutBookingPortalInvitations(bookingId: $bookingId) {
    id
    bookingId
    guestId
    email
    givenName
    familyName
    created
  }
}
    `;

/**
 * __useGetCheckoutBookingPortalInvitationsQuery__
 *
 * To run a query within a React component, call `useGetCheckoutBookingPortalInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutBookingPortalInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutBookingPortalInvitationsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetCheckoutBookingPortalInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables> & ({ variables: GetCheckoutBookingPortalInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables>(GetCheckoutBookingPortalInvitationsDocument, options);
      }
export function useGetCheckoutBookingPortalInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables>(GetCheckoutBookingPortalInvitationsDocument, options);
        }
export function useGetCheckoutBookingPortalInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables>(GetCheckoutBookingPortalInvitationsDocument, options);
        }
export type GetCheckoutBookingPortalInvitationsQueryHookResult = ReturnType<typeof useGetCheckoutBookingPortalInvitationsQuery>;
export type GetCheckoutBookingPortalInvitationsLazyQueryHookResult = ReturnType<typeof useGetCheckoutBookingPortalInvitationsLazyQuery>;
export type GetCheckoutBookingPortalInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetCheckoutBookingPortalInvitationsSuspenseQuery>;
export type GetCheckoutBookingPortalInvitationsQueryResult = Apollo.QueryResult<GetCheckoutBookingPortalInvitationsQuery, GetCheckoutBookingPortalInvitationsQueryVariables>;
export const GetCitiesAndPrefecturesWithProductsDocument = gql`
    query getCitiesAndPrefecturesWithProducts {
  locations(
    input: {hasProducts: true, locationTypes: [PREFECTURE, CITY], order: {field: "NUM_PRODUCTS", direction: DESC}}
  ) {
    records {
      id
      slug
      destinationNames
      navImageUrl
      country {
        id
        name
      }
      translation(lang: en) {
        name
      }
    }
  }
}
    `;

/**
 * __useGetCitiesAndPrefecturesWithProductsQuery__
 *
 * To run a query within a React component, call `useGetCitiesAndPrefecturesWithProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesAndPrefecturesWithProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesAndPrefecturesWithProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesAndPrefecturesWithProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>(GetCitiesAndPrefecturesWithProductsDocument, options);
      }
export function useGetCitiesAndPrefecturesWithProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>(GetCitiesAndPrefecturesWithProductsDocument, options);
        }
export function useGetCitiesAndPrefecturesWithProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>(GetCitiesAndPrefecturesWithProductsDocument, options);
        }
export type GetCitiesAndPrefecturesWithProductsQueryHookResult = ReturnType<typeof useGetCitiesAndPrefecturesWithProductsQuery>;
export type GetCitiesAndPrefecturesWithProductsLazyQueryHookResult = ReturnType<typeof useGetCitiesAndPrefecturesWithProductsLazyQuery>;
export type GetCitiesAndPrefecturesWithProductsSuspenseQueryHookResult = ReturnType<typeof useGetCitiesAndPrefecturesWithProductsSuspenseQuery>;
export type GetCitiesAndPrefecturesWithProductsQueryResult = Apollo.QueryResult<GetCitiesAndPrefecturesWithProductsQuery, GetCitiesAndPrefecturesWithProductsQueryVariables>;
export const GetCityAvailableProductsDocument = gql`
    query getCityAvailableProducts($locationId: ID, $language: Iso639!, $currency: Currency!, $fromDate: Date!, $untilDate: Date!) {
  products(input: {locationId: $locationId}) {
    totalRecords
    records {
      id
      availability(fromDate: $fromDate, untilDate: $untilDate) {
        date
        status
      }
      translation(lang: $language) {
        name
      }
      duration
      mainImage
      tags {
        id
        translation(lang: $language) {
          name
        }
      }
      displayPrice(currency: $currency) {
        amount
        currency
        isGroup
      }
      reviewSummary {
        average
        numReviews
      }
    }
  }
}
    `;

/**
 * __useGetCityAvailableProductsQuery__
 *
 * To run a query within a React component, call `useGetCityAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityAvailableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityAvailableProductsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      language: // value for 'language'
 *      currency: // value for 'currency'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetCityAvailableProductsQuery(baseOptions: Apollo.QueryHookOptions<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables> & ({ variables: GetCityAvailableProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables>(GetCityAvailableProductsDocument, options);
      }
export function useGetCityAvailableProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables>(GetCityAvailableProductsDocument, options);
        }
export function useGetCityAvailableProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables>(GetCityAvailableProductsDocument, options);
        }
export type GetCityAvailableProductsQueryHookResult = ReturnType<typeof useGetCityAvailableProductsQuery>;
export type GetCityAvailableProductsLazyQueryHookResult = ReturnType<typeof useGetCityAvailableProductsLazyQuery>;
export type GetCityAvailableProductsSuspenseQueryHookResult = ReturnType<typeof useGetCityAvailableProductsSuspenseQuery>;
export type GetCityAvailableProductsQueryResult = Apollo.QueryResult<GetCityAvailableProductsQuery, GetCityAvailableProductsQueryVariables>;
export const GetCountriesCitiesAndPrefecturesWithProductsDocument = gql`
    query getCountriesCitiesAndPrefecturesWithProducts {
  locations(
    input: {hasProducts: true, locationTypes: [COUNTRY, PREFECTURE, CITY], order: {field: "NUM_PRODUCTS", direction: DESC}}
  ) {
    records {
      id
      destinationNames
      country {
        id
        name
      }
      translation(lang: en) {
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountriesCitiesAndPrefecturesWithProductsQuery__
 *
 * To run a query within a React component, call `useGetCountriesCitiesAndPrefecturesWithProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesCitiesAndPrefecturesWithProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesCitiesAndPrefecturesWithProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesCitiesAndPrefecturesWithProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>(GetCountriesCitiesAndPrefecturesWithProductsDocument, options);
      }
export function useGetCountriesCitiesAndPrefecturesWithProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>(GetCountriesCitiesAndPrefecturesWithProductsDocument, options);
        }
export function useGetCountriesCitiesAndPrefecturesWithProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>(GetCountriesCitiesAndPrefecturesWithProductsDocument, options);
        }
export type GetCountriesCitiesAndPrefecturesWithProductsQueryHookResult = ReturnType<typeof useGetCountriesCitiesAndPrefecturesWithProductsQuery>;
export type GetCountriesCitiesAndPrefecturesWithProductsLazyQueryHookResult = ReturnType<typeof useGetCountriesCitiesAndPrefecturesWithProductsLazyQuery>;
export type GetCountriesCitiesAndPrefecturesWithProductsSuspenseQueryHookResult = ReturnType<typeof useGetCountriesCitiesAndPrefecturesWithProductsSuspenseQuery>;
export type GetCountriesCitiesAndPrefecturesWithProductsQueryResult = Apollo.QueryResult<GetCountriesCitiesAndPrefecturesWithProductsQuery, GetCountriesCitiesAndPrefecturesWithProductsQueryVariables>;
export const GetCurrentStorefrontSessionDocument = gql`
    query GetCurrentStorefrontSession {
  currentStorefrontSession {
    id
    guests {
      email
      familyName
      givenName
      id
      phoneNumber
      isLeadGuest
      review {
        id
        score
        reviewText
      }
      booking {
        id
        numPeople
        guests {
          id
          isLeadGuest
          familyName
          givenName
          email
          phoneNumber
        }
        group {
          id
          date
          time
          hasMedia
          guideAssignments {
            role
            guide {
              nickName
              profilePic
              translation(lang: en) {
                description
              }
            }
          }
          product {
            id
            name
            poster
            duration
            location {
              country {
                name
              }
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentStorefrontSessionQuery__
 *
 * To run a query within a React component, call `useGetCurrentStorefrontSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStorefrontSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStorefrontSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentStorefrontSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>(GetCurrentStorefrontSessionDocument, options);
      }
export function useGetCurrentStorefrontSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>(GetCurrentStorefrontSessionDocument, options);
        }
export function useGetCurrentStorefrontSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>(GetCurrentStorefrontSessionDocument, options);
        }
export type GetCurrentStorefrontSessionQueryHookResult = ReturnType<typeof useGetCurrentStorefrontSessionQuery>;
export type GetCurrentStorefrontSessionLazyQueryHookResult = ReturnType<typeof useGetCurrentStorefrontSessionLazyQuery>;
export type GetCurrentStorefrontSessionSuspenseQueryHookResult = ReturnType<typeof useGetCurrentStorefrontSessionSuspenseQuery>;
export type GetCurrentStorefrontSessionQueryResult = Apollo.QueryResult<GetCurrentStorefrontSessionQuery, GetCurrentStorefrontSessionQueryVariables>;
export const GetCurrentStorefrontSessionForPortalDocument = gql`
    query GetCurrentStorefrontSessionForPortal($bookingId: ID) {
  currentStorefrontSession(bookingId: $bookingId) {
    id
    bookingId
    scope
    guest {
      id
      bookingId
      email
      familyName
      givenName
      phoneNumber
      isLeadGuest
      review {
        id
        score
        reviewText
      }
      booking {
        id
        numPeople
      }
    }
    guests {
      email
      familyName
      givenName
      id
      phoneNumber
      isLeadGuest
      review {
        id
        score
        reviewText
      }
      booking {
        id
        numPeople
        guests {
          id
          isLeadGuest
          familyName
          givenName
          email
          phoneNumber
        }
        group {
          id
          date
          time
          hasEnded
          hasMedia
          guideAssignments {
            role
            guide {
              nickName
              profilePic
              translation(lang: en) {
                description
              }
            }
          }
          product {
            id
            name
            poster
            duration
            location {
              country {
                name
              }
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentStorefrontSessionForPortalQuery__
 *
 * To run a query within a React component, call `useGetCurrentStorefrontSessionForPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStorefrontSessionForPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStorefrontSessionForPortalQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetCurrentStorefrontSessionForPortalQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>(GetCurrentStorefrontSessionForPortalDocument, options);
      }
export function useGetCurrentStorefrontSessionForPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>(GetCurrentStorefrontSessionForPortalDocument, options);
        }
export function useGetCurrentStorefrontSessionForPortalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>(GetCurrentStorefrontSessionForPortalDocument, options);
        }
export type GetCurrentStorefrontSessionForPortalQueryHookResult = ReturnType<typeof useGetCurrentStorefrontSessionForPortalQuery>;
export type GetCurrentStorefrontSessionForPortalLazyQueryHookResult = ReturnType<typeof useGetCurrentStorefrontSessionForPortalLazyQuery>;
export type GetCurrentStorefrontSessionForPortalSuspenseQueryHookResult = ReturnType<typeof useGetCurrentStorefrontSessionForPortalSuspenseQuery>;
export type GetCurrentStorefrontSessionForPortalQueryResult = Apollo.QueryResult<GetCurrentStorefrontSessionForPortalQuery, GetCurrentStorefrontSessionForPortalQueryVariables>;
export const GetCustomTourFaqsDocument = gql`
    query getCustomTourFaqs {
  faqs(input: {context: CUSTOM_TOURS}) {
    records {
      id
      questionsAndAnswers {
        id
        question
        answer
      }
    }
  }
}
    `;

/**
 * __useGetCustomTourFaqsQuery__
 *
 * To run a query within a React component, call `useGetCustomTourFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomTourFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomTourFaqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomTourFaqsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>(GetCustomTourFaqsDocument, options);
      }
export function useGetCustomTourFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>(GetCustomTourFaqsDocument, options);
        }
export function useGetCustomTourFaqsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>(GetCustomTourFaqsDocument, options);
        }
export type GetCustomTourFaqsQueryHookResult = ReturnType<typeof useGetCustomTourFaqsQuery>;
export type GetCustomTourFaqsLazyQueryHookResult = ReturnType<typeof useGetCustomTourFaqsLazyQuery>;
export type GetCustomTourFaqsSuspenseQueryHookResult = ReturnType<typeof useGetCustomTourFaqsSuspenseQuery>;
export type GetCustomTourFaqsQueryResult = Apollo.QueryResult<GetCustomTourFaqsQuery, GetCustomTourFaqsQueryVariables>;
export const GetFeaturedBannersDocument = gql`
    query getFeaturedBanners($showHome: Boolean, $locationId: ID) {
  featuredBanners(showHome: $showHome, locationId: $locationId) {
    title
    imageUrl
    pageUrl
    ctaText
  }
}
    `;

/**
 * __useGetFeaturedBannersQuery__
 *
 * To run a query within a React component, call `useGetFeaturedBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedBannersQuery({
 *   variables: {
 *      showHome: // value for 'showHome'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetFeaturedBannersQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>(GetFeaturedBannersDocument, options);
      }
export function useGetFeaturedBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>(GetFeaturedBannersDocument, options);
        }
export function useGetFeaturedBannersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>(GetFeaturedBannersDocument, options);
        }
export type GetFeaturedBannersQueryHookResult = ReturnType<typeof useGetFeaturedBannersQuery>;
export type GetFeaturedBannersLazyQueryHookResult = ReturnType<typeof useGetFeaturedBannersLazyQuery>;
export type GetFeaturedBannersSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedBannersSuspenseQuery>;
export type GetFeaturedBannersQueryResult = Apollo.QueryResult<GetFeaturedBannersQuery, GetFeaturedBannersQueryVariables>;
export const GetGuestReviewDocument = gql`
    query GetGuestReview($guestId: ID!) {
  getGuestReview(guestId: $guestId) {
    reviewSource
    reviewSourceUrl
  }
}
    `;

/**
 * __useGetGuestReviewQuery__
 *
 * To run a query within a React component, call `useGetGuestReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestReviewQuery({
 *   variables: {
 *      guestId: // value for 'guestId'
 *   },
 * });
 */
export function useGetGuestReviewQuery(baseOptions: Apollo.QueryHookOptions<GetGuestReviewQuery, GetGuestReviewQueryVariables> & ({ variables: GetGuestReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestReviewQuery, GetGuestReviewQueryVariables>(GetGuestReviewDocument, options);
      }
export function useGetGuestReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestReviewQuery, GetGuestReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestReviewQuery, GetGuestReviewQueryVariables>(GetGuestReviewDocument, options);
        }
export function useGetGuestReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuestReviewQuery, GetGuestReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestReviewQuery, GetGuestReviewQueryVariables>(GetGuestReviewDocument, options);
        }
export type GetGuestReviewQueryHookResult = ReturnType<typeof useGetGuestReviewQuery>;
export type GetGuestReviewLazyQueryHookResult = ReturnType<typeof useGetGuestReviewLazyQuery>;
export type GetGuestReviewSuspenseQueryHookResult = ReturnType<typeof useGetGuestReviewSuspenseQuery>;
export type GetGuestReviewQueryResult = Apollo.QueryResult<GetGuestReviewQuery, GetGuestReviewQueryVariables>;
export const GetLocationItinerariesDocument = gql`
    query getLocationItineraries($input: MultidayItinerariesInput) {
  multidayItineraries(input: $input) {
    records {
      id
      name
      slug
      description
      imageThumbnail
      location {
        translations {
          lang
          name
        }
        country {
          name
        }
      }
      days {
        id
        blocks {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationItinerariesQuery__
 *
 * To run a query within a React component, call `useGetLocationItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationItinerariesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLocationItinerariesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>(GetLocationItinerariesDocument, options);
      }
export function useGetLocationItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>(GetLocationItinerariesDocument, options);
        }
export function useGetLocationItinerariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>(GetLocationItinerariesDocument, options);
        }
export type GetLocationItinerariesQueryHookResult = ReturnType<typeof useGetLocationItinerariesQuery>;
export type GetLocationItinerariesLazyQueryHookResult = ReturnType<typeof useGetLocationItinerariesLazyQuery>;
export type GetLocationItinerariesSuspenseQueryHookResult = ReturnType<typeof useGetLocationItinerariesSuspenseQuery>;
export type GetLocationItinerariesQueryResult = Apollo.QueryResult<GetLocationItinerariesQuery, GetLocationItinerariesQueryVariables>;
export const GetInterviewArticleDocument = gql`
    query GetInterviewArticle($slug: String!, $lang: Iso639!, $currency: Currency!, $fromDate: Date!, $untilDate: Date!) {
  interviewArticle(slug: $slug) {
    id
    slug
    title
    content
    metaTitle
    metaDescription
    products {
      id
      poster
      duration
      translation(lang: $lang) {
        ...ProductTranslationFields
      }
      displayPrice(currency: $currency) {
        ...ProductDisplayPriceFields
      }
      reviewSummary {
        average
        numReviews
      }
      tags {
        ...TagFields
        translation(lang: $lang) {
          ...TagTranslationFields
        }
      }
      earliestAvailability(fromDate: $fromDate, untilDate: $untilDate, groupSize: 1)
      availability(fromDate: $fromDate, untilDate: $untilDate, groupSize: 1) {
        ...ProductAvailabilityFields
      }
    }
  }
}
    ${ProductTranslationFieldsFragmentDoc}
${ProductDisplayPriceFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductAvailabilityFieldsFragmentDoc}`;

/**
 * __useGetInterviewArticleQuery__
 *
 * To run a query within a React component, call `useGetInterviewArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewArticleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      lang: // value for 'lang'
 *      currency: // value for 'currency'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetInterviewArticleQuery(baseOptions: Apollo.QueryHookOptions<GetInterviewArticleQuery, GetInterviewArticleQueryVariables> & ({ variables: GetInterviewArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterviewArticleQuery, GetInterviewArticleQueryVariables>(GetInterviewArticleDocument, options);
      }
export function useGetInterviewArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewArticleQuery, GetInterviewArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterviewArticleQuery, GetInterviewArticleQueryVariables>(GetInterviewArticleDocument, options);
        }
export function useGetInterviewArticleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInterviewArticleQuery, GetInterviewArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInterviewArticleQuery, GetInterviewArticleQueryVariables>(GetInterviewArticleDocument, options);
        }
export type GetInterviewArticleQueryHookResult = ReturnType<typeof useGetInterviewArticleQuery>;
export type GetInterviewArticleLazyQueryHookResult = ReturnType<typeof useGetInterviewArticleLazyQuery>;
export type GetInterviewArticleSuspenseQueryHookResult = ReturnType<typeof useGetInterviewArticleSuspenseQuery>;
export type GetInterviewArticleQueryResult = Apollo.QueryResult<GetInterviewArticleQuery, GetInterviewArticleQueryVariables>;
export const GetMultidayItinerariesListDocument = gql`
    query GetMultidayItinerariesList($input: MultidayItinerariesInput) {
  multidayItineraries(input: $input) {
    totalRecords
    records {
      id
      name
      slug
      description
      imageThumbnail
      published
      location {
        translations {
          lang
          name
        }
        country {
          name
        }
      }
      days {
        id
        blocks {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetMultidayItinerariesListQuery__
 *
 * To run a query within a React component, call `useGetMultidayItinerariesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultidayItinerariesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultidayItinerariesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMultidayItinerariesListQuery(baseOptions?: Apollo.QueryHookOptions<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>(GetMultidayItinerariesListDocument, options);
      }
export function useGetMultidayItinerariesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>(GetMultidayItinerariesListDocument, options);
        }
export function useGetMultidayItinerariesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>(GetMultidayItinerariesListDocument, options);
        }
export type GetMultidayItinerariesListQueryHookResult = ReturnType<typeof useGetMultidayItinerariesListQuery>;
export type GetMultidayItinerariesListLazyQueryHookResult = ReturnType<typeof useGetMultidayItinerariesListLazyQuery>;
export type GetMultidayItinerariesListSuspenseQueryHookResult = ReturnType<typeof useGetMultidayItinerariesListSuspenseQuery>;
export type GetMultidayItinerariesListQueryResult = Apollo.QueryResult<GetMultidayItinerariesListQuery, GetMultidayItinerariesListQueryVariables>;
export const GetMultidayItineraryDocument = gql`
    query GetMultidayItinerary($multidayItinerarySlug: String!) {
  multidayItinerary(slug: $multidayItinerarySlug) {
    id
    name
    slug
    description
    bannerTitle
    bannerDescription
    locationId
    location {
      id
      slug
      translations {
        lang
        id
        name
      }
      country {
        id
        name
      }
    }
    published
    created
    metaDescription
    imageUrl
    imageThumbnail
    metaTitle
    days {
      id
      dayNumber
      title
      description
      blocks {
        id
        type
        content
        time
        title
        stepOrder
        product {
          id
          poster
          tags {
            id
          }
          translations {
            name
            lang
          }
        }
      }
    }
    lastPublished
  }
}
    `;

/**
 * __useGetMultidayItineraryQuery__
 *
 * To run a query within a React component, call `useGetMultidayItineraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultidayItineraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultidayItineraryQuery({
 *   variables: {
 *      multidayItinerarySlug: // value for 'multidayItinerarySlug'
 *   },
 * });
 */
export function useGetMultidayItineraryQuery(baseOptions: Apollo.QueryHookOptions<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables> & ({ variables: GetMultidayItineraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables>(GetMultidayItineraryDocument, options);
      }
export function useGetMultidayItineraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables>(GetMultidayItineraryDocument, options);
        }
export function useGetMultidayItinerarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables>(GetMultidayItineraryDocument, options);
        }
export type GetMultidayItineraryQueryHookResult = ReturnType<typeof useGetMultidayItineraryQuery>;
export type GetMultidayItineraryLazyQueryHookResult = ReturnType<typeof useGetMultidayItineraryLazyQuery>;
export type GetMultidayItinerarySuspenseQueryHookResult = ReturnType<typeof useGetMultidayItinerarySuspenseQuery>;
export type GetMultidayItineraryQueryResult = Apollo.QueryResult<GetMultidayItineraryQuery, GetMultidayItineraryQueryVariables>;
export const NextAvailableGuidesDocument = gql`
    query NextAvailableGuides($input: NextAvailableGuidesInput!, $lang: Iso639!) {
  nextAvailableGuides(input: $input) {
    id
    date
    time
    mainGuide {
      id
      nickName
      profilePic
      profileVideo
      metrics {
        numTours
        numPeople
      }
      translation(lang: $lang) {
        description
      }
    }
  }
}
    `;

/**
 * __useNextAvailableGuidesQuery__
 *
 * To run a query within a React component, call `useNextAvailableGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextAvailableGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextAvailableGuidesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useNextAvailableGuidesQuery(baseOptions: Apollo.QueryHookOptions<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables> & ({ variables: NextAvailableGuidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>(NextAvailableGuidesDocument, options);
      }
export function useNextAvailableGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>(NextAvailableGuidesDocument, options);
        }
export function useNextAvailableGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>(NextAvailableGuidesDocument, options);
        }
export type NextAvailableGuidesQueryHookResult = ReturnType<typeof useNextAvailableGuidesQuery>;
export type NextAvailableGuidesLazyQueryHookResult = ReturnType<typeof useNextAvailableGuidesLazyQuery>;
export type NextAvailableGuidesSuspenseQueryHookResult = ReturnType<typeof useNextAvailableGuidesSuspenseQuery>;
export type NextAvailableGuidesQueryResult = Apollo.QueryResult<NextAvailableGuidesQuery, NextAvailableGuidesQueryVariables>;
export const GetPageCarouselsDocument = gql`
    query getPageCarousels($locationId: ID!, $currency: Currency!, $lang: Iso639!) {
  pageCarousels(locationId: $locationId) {
    ...PageCarouselFields
  }
}
    ${PageCarouselFieldsFragmentDoc}
${ProductDisplayPriceFieldsFragmentDoc}`;

/**
 * __useGetPageCarouselsQuery__
 *
 * To run a query within a React component, call `useGetPageCarouselsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageCarouselsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageCarouselsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetPageCarouselsQuery(baseOptions: Apollo.QueryHookOptions<GetPageCarouselsQuery, GetPageCarouselsQueryVariables> & ({ variables: GetPageCarouselsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageCarouselsQuery, GetPageCarouselsQueryVariables>(GetPageCarouselsDocument, options);
      }
export function useGetPageCarouselsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageCarouselsQuery, GetPageCarouselsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageCarouselsQuery, GetPageCarouselsQueryVariables>(GetPageCarouselsDocument, options);
        }
export function useGetPageCarouselsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageCarouselsQuery, GetPageCarouselsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageCarouselsQuery, GetPageCarouselsQueryVariables>(GetPageCarouselsDocument, options);
        }
export type GetPageCarouselsQueryHookResult = ReturnType<typeof useGetPageCarouselsQuery>;
export type GetPageCarouselsLazyQueryHookResult = ReturnType<typeof useGetPageCarouselsLazyQuery>;
export type GetPageCarouselsSuspenseQueryHookResult = ReturnType<typeof useGetPageCarouselsSuspenseQuery>;
export type GetPageCarouselsQueryResult = Apollo.QueryResult<GetPageCarouselsQuery, GetPageCarouselsQueryVariables>;
export const GetPosterProductsDocument = gql`
    query getPosterProducts($offset: Int, $limit: Int, $locationId: ID, $language: Iso639!, $currency: Currency!, $ids: [ID!]) {
  products(
    input: {offset: $offset, limit: $limit, locationId: $locationId, ids: $ids}
  ) {
    totalRecords
    records {
      id
      translation(lang: $language) {
        name
        headline
      }
      duration
      poster
      tags {
        id
        translation(lang: $language) {
          name
        }
      }
      displayPrice(currency: $currency) {
        amount
        currency
        isGroup
      }
      reviewSummary {
        average
        numReviews
      }
    }
  }
}
    `;

/**
 * __useGetPosterProductsQuery__
 *
 * To run a query within a React component, call `useGetPosterProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosterProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosterProductsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *      language: // value for 'language'
 *      currency: // value for 'currency'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPosterProductsQuery(baseOptions: Apollo.QueryHookOptions<GetPosterProductsQuery, GetPosterProductsQueryVariables> & ({ variables: GetPosterProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosterProductsQuery, GetPosterProductsQueryVariables>(GetPosterProductsDocument, options);
      }
export function useGetPosterProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosterProductsQuery, GetPosterProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosterProductsQuery, GetPosterProductsQueryVariables>(GetPosterProductsDocument, options);
        }
export function useGetPosterProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPosterProductsQuery, GetPosterProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPosterProductsQuery, GetPosterProductsQueryVariables>(GetPosterProductsDocument, options);
        }
export type GetPosterProductsQueryHookResult = ReturnType<typeof useGetPosterProductsQuery>;
export type GetPosterProductsLazyQueryHookResult = ReturnType<typeof useGetPosterProductsLazyQuery>;
export type GetPosterProductsSuspenseQueryHookResult = ReturnType<typeof useGetPosterProductsSuspenseQuery>;
export type GetPosterProductsQueryResult = Apollo.QueryResult<GetPosterProductsQuery, GetPosterProductsQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($productKey: ProductKey!, $currency: Currency, $lang: Iso639!) {
  product(input: $productKey) {
    ...ProductFields
    announcement {
      content
      active
    }
    translation(lang: $lang) {
      ...ProductTranslationFields
    }
    prices(currency: $currency) {
      ...ProductPriceFields
    }
    privatePrices(currency: $currency) {
      ...ProductPrivatePriceFields
    }
    faqs(lang: $lang) {
      ...ProductFAQFields
    }
    featuredGuide {
      ...GuideFields
      isActive
    }
    youtubes {
      ...ProductYouTubeFields
    }
    reviewSummary {
      average
      numReviews
    }
    tags {
      ...TagFields
      translation(lang: $lang) {
        ...TagTranslationFields
      }
    }
    media {
      ...ProductMediaFields
    }
    details {
      media {
        ...ProductDetailMediaFields
      }
      translation(lang: $lang) {
        ...ProductDetailTranslationFields
      }
    }
    location {
      ...LocationFields
      translation(lang: $lang) {
        ...LocationTranslationFields
      }
    }
    inclusions {
      ...ProductInclusionFields
      translation(lang: $lang) {
        ...ProductInclusionTranslationFields
      }
    }
    dietaryRestrictions {
      ...ProductDietaryRestrictionsFields
    }
    recentPhotos
    requiresTransportAgreement
    willInfluencerGuide
    influencer {
      id
      name
      tiktokUrl
      xUrl
      youtubeUrl
      instagramUrl
      iconSrc
      guide {
        id
        nickName
      }
    }
    hasAccomodationVehiclePickup
    hasDefaultVehiclePickup
    pickupLocationZone {
      center {
        lat
        lng
      }
      radius
    }
  }
}
    ${ProductFieldsFragmentDoc}
${ProductTranslationFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}
${ProductPrivatePriceFieldsFragmentDoc}
${ProductFaqFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${ProductYouTubeFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductMediaFieldsFragmentDoc}
${ProductDetailMediaFieldsFragmentDoc}
${ProductDetailTranslationFieldsFragmentDoc}
${LocationFieldsFragmentDoc}
${LocationTranslationFieldsFragmentDoc}
${ProductInclusionFieldsFragmentDoc}
${ProductInclusionTranslationFieldsFragmentDoc}
${ProductDietaryRestrictionsFieldsFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      productKey: // value for 'productKey'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductAnnouncementDocument = gql`
    query getProductAnnouncement($productId: ID!) {
  product(input: {id: $productId}) {
    announcement {
      content
      active
    }
  }
}
    `;

/**
 * __useGetProductAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetProductAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAnnouncementQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductAnnouncementQuery(baseOptions: Apollo.QueryHookOptions<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables> & ({ variables: GetProductAnnouncementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables>(GetProductAnnouncementDocument, options);
      }
export function useGetProductAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables>(GetProductAnnouncementDocument, options);
        }
export function useGetProductAnnouncementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables>(GetProductAnnouncementDocument, options);
        }
export type GetProductAnnouncementQueryHookResult = ReturnType<typeof useGetProductAnnouncementQuery>;
export type GetProductAnnouncementLazyQueryHookResult = ReturnType<typeof useGetProductAnnouncementLazyQuery>;
export type GetProductAnnouncementSuspenseQueryHookResult = ReturnType<typeof useGetProductAnnouncementSuspenseQuery>;
export type GetProductAnnouncementQueryResult = Apollo.QueryResult<GetProductAnnouncementQuery, GetProductAnnouncementQueryVariables>;
export const GetProductAvailabilitiesDocument = gql`
    query getProductAvailabilities($productId: ID!, $lang: Iso639!, $fromDate: Date!, $untilDate: Date!) {
  product(input: {id: $productId}) {
    availability(fromDate: $fromDate, untilDate: $untilDate) {
      ...ProductAvailabilityFields
      timeSlots {
        ...ProductAvailabilityTimeFields
        groups {
          ...ProductAvailabilityGroupFields
          guides {
            ...GuideFields
            translation(lang: $lang) {
              ...GuideTranslationFields
            }
          }
        }
      }
    }
  }
}
    ${ProductAvailabilityFieldsFragmentDoc}
${ProductAvailabilityTimeFieldsFragmentDoc}
${ProductAvailabilityGroupFieldsFragmentDoc}
${GuideFieldsFragmentDoc}
${GuideTranslationFieldsFragmentDoc}`;

/**
 * __useGetProductAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetProductAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAvailabilitiesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      lang: // value for 'lang'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetProductAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables> & ({ variables: GetProductAvailabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>(GetProductAvailabilitiesDocument, options);
      }
export function useGetProductAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>(GetProductAvailabilitiesDocument, options);
        }
export function useGetProductAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>(GetProductAvailabilitiesDocument, options);
        }
export type GetProductAvailabilitiesQueryHookResult = ReturnType<typeof useGetProductAvailabilitiesQuery>;
export type GetProductAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetProductAvailabilitiesLazyQuery>;
export type GetProductAvailabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetProductAvailabilitiesSuspenseQuery>;
export type GetProductAvailabilitiesQueryResult = Apollo.QueryResult<GetProductAvailabilitiesQuery, GetProductAvailabilitiesQueryVariables>;
export const GetProductAvailabilityDocument = gql`
    query getProductAvailability($productId: ID!, $fromDate: Date!, $untilDate: Date!) {
  product(input: {id: $productId}) {
    id
    location {
      timezone
    }
    availability(fromDate: $fromDate, untilDate: $untilDate) {
      date
      status
      timeSlots {
        time
        status
        groups {
          id
          seatsAvailable
          isEmpty
          isPrivate
          canBecomePublic
          guides {
            id
            nickName
            profilePic
            profileVideo
            reviewSummary {
              average
              numReviews
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetProductAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAvailabilityQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetProductAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables> & ({ variables: GetProductAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>(GetProductAvailabilityDocument, options);
      }
export function useGetProductAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>(GetProductAvailabilityDocument, options);
        }
export function useGetProductAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>(GetProductAvailabilityDocument, options);
        }
export type GetProductAvailabilityQueryHookResult = ReturnType<typeof useGetProductAvailabilityQuery>;
export type GetProductAvailabilityLazyQueryHookResult = ReturnType<typeof useGetProductAvailabilityLazyQuery>;
export type GetProductAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetProductAvailabilitySuspenseQuery>;
export type GetProductAvailabilityQueryResult = Apollo.QueryResult<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>;
export const GetProductAvailabilityStatusDocument = gql`
    query getProductAvailabilityStatus($productId: ID!, $fromDate: Date!, $untilDate: Date!) {
  product(input: {id: $productId}) {
    availability(fromDate: $fromDate, untilDate: $untilDate) {
      date
      status
    }
  }
}
    `;

/**
 * __useGetProductAvailabilityStatusQuery__
 *
 * To run a query within a React component, call `useGetProductAvailabilityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAvailabilityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAvailabilityStatusQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetProductAvailabilityStatusQuery(baseOptions: Apollo.QueryHookOptions<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables> & ({ variables: GetProductAvailabilityStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables>(GetProductAvailabilityStatusDocument, options);
      }
export function useGetProductAvailabilityStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables>(GetProductAvailabilityStatusDocument, options);
        }
export function useGetProductAvailabilityStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables>(GetProductAvailabilityStatusDocument, options);
        }
export type GetProductAvailabilityStatusQueryHookResult = ReturnType<typeof useGetProductAvailabilityStatusQuery>;
export type GetProductAvailabilityStatusLazyQueryHookResult = ReturnType<typeof useGetProductAvailabilityStatusLazyQuery>;
export type GetProductAvailabilityStatusSuspenseQueryHookResult = ReturnType<typeof useGetProductAvailabilityStatusSuspenseQuery>;
export type GetProductAvailabilityStatusQueryResult = Apollo.QueryResult<GetProductAvailabilityStatusQuery, GetProductAvailabilityStatusQueryVariables>;
export const GetProductCardsDocument = gql`
    query getProductCards($offset: Int, $limit: Int, $language: Iso639!, $currency: Currency!, $tags: [ID!], $locationId: ID) {
  products(
    input: {offset: $offset, limit: $limit, tagIds: $tags, locationId: $locationId}
  ) {
    totalRecords
    records {
      id
      translation(lang: $language) {
        name
      }
      duration
      poster
      location {
        translation(lang: $language) {
          name
        }
      }
      tags {
        id
        translation(lang: $language) {
          name
        }
      }
      displayPrice(currency: $currency) {
        amount
        currency
        isGroup
      }
      reviewSummary {
        average
        numReviews
      }
    }
  }
}
    `;

/**
 * __useGetProductCardsQuery__
 *
 * To run a query within a React component, call `useGetProductCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCardsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      language: // value for 'language'
 *      currency: // value for 'currency'
 *      tags: // value for 'tags'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetProductCardsQuery(baseOptions: Apollo.QueryHookOptions<GetProductCardsQuery, GetProductCardsQueryVariables> & ({ variables: GetProductCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCardsQuery, GetProductCardsQueryVariables>(GetProductCardsDocument, options);
      }
export function useGetProductCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCardsQuery, GetProductCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCardsQuery, GetProductCardsQueryVariables>(GetProductCardsDocument, options);
        }
export function useGetProductCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductCardsQuery, GetProductCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCardsQuery, GetProductCardsQueryVariables>(GetProductCardsDocument, options);
        }
export type GetProductCardsQueryHookResult = ReturnType<typeof useGetProductCardsQuery>;
export type GetProductCardsLazyQueryHookResult = ReturnType<typeof useGetProductCardsLazyQuery>;
export type GetProductCardsSuspenseQueryHookResult = ReturnType<typeof useGetProductCardsSuspenseQuery>;
export type GetProductCardsQueryResult = Apollo.QueryResult<GetProductCardsQuery, GetProductCardsQueryVariables>;
export const GetProductCollectionDocument = gql`
    query getProductCollection($id: ID, $slug: String, $fromDate: Date!, $untilDate: Date!, $currency: Currency!, $lang: Iso639!) {
  productCollection(id: $id, slug: $slug) {
    ...ProductCollectionFields
    ...ProductCollectionProductFields
  }
}
    ${ProductCollectionFieldsFragmentDoc}
${ProductCollectionProductFieldsFragmentDoc}
${ProductDisplayPriceFieldsFragmentDoc}`;

/**
 * __useGetProductCollectionQuery__
 *
 * To run a query within a React component, call `useGetProductCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProductCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetProductCollectionQuery, GetProductCollectionQueryVariables> & ({ variables: GetProductCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCollectionQuery, GetProductCollectionQueryVariables>(GetProductCollectionDocument, options);
      }
export function useGetProductCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCollectionQuery, GetProductCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCollectionQuery, GetProductCollectionQueryVariables>(GetProductCollectionDocument, options);
        }
export function useGetProductCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductCollectionQuery, GetProductCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCollectionQuery, GetProductCollectionQueryVariables>(GetProductCollectionDocument, options);
        }
export type GetProductCollectionQueryHookResult = ReturnType<typeof useGetProductCollectionQuery>;
export type GetProductCollectionLazyQueryHookResult = ReturnType<typeof useGetProductCollectionLazyQuery>;
export type GetProductCollectionSuspenseQueryHookResult = ReturnType<typeof useGetProductCollectionSuspenseQuery>;
export type GetProductCollectionQueryResult = Apollo.QueryResult<GetProductCollectionQuery, GetProductCollectionQueryVariables>;
export const GetProductCollectionsDocument = gql`
    query getProductCollections($id: ID!, $currency: Currency!, $lang: Iso639!, $fromDate: Date!, $untilDate: Date!) {
  productCollections {
    totalRecords
    records {
      ...ProductCollectionFields
      ...ProductCollectionProductFields
    }
  }
}
    ${ProductCollectionFieldsFragmentDoc}
${ProductCollectionProductFieldsFragmentDoc}
${ProductDisplayPriceFieldsFragmentDoc}`;

/**
 * __useGetProductCollectionsQuery__
 *
 * To run a query within a React component, call `useGetProductCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCollectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currency: // value for 'currency'
 *      lang: // value for 'lang'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *   },
 * });
 */
export function useGetProductCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetProductCollectionsQuery, GetProductCollectionsQueryVariables> & ({ variables: GetProductCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>(GetProductCollectionsDocument, options);
      }
export function useGetProductCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>(GetProductCollectionsDocument, options);
        }
export function useGetProductCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>(GetProductCollectionsDocument, options);
        }
export type GetProductCollectionsQueryHookResult = ReturnType<typeof useGetProductCollectionsQuery>;
export type GetProductCollectionsLazyQueryHookResult = ReturnType<typeof useGetProductCollectionsLazyQuery>;
export type GetProductCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetProductCollectionsSuspenseQuery>;
export type GetProductCollectionsQueryResult = Apollo.QueryResult<GetProductCollectionsQuery, GetProductCollectionsQueryVariables>;
export const GetProductPriceDocument = gql`
    query getProductPrice($productId: ID!, $currency: Currency) {
  product(input: {id: $productId}) {
    id
    displayPrice(currency: $currency) {
      amount
      currency
      isGroup
      originalPrice
    }
  }
}
    `;

/**
 * __useGetProductPriceQuery__
 *
 * To run a query within a React component, call `useGetProductPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPriceQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetProductPriceQuery(baseOptions: Apollo.QueryHookOptions<GetProductPriceQuery, GetProductPriceQueryVariables> & ({ variables: GetProductPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPriceQuery, GetProductPriceQueryVariables>(GetProductPriceDocument, options);
      }
export function useGetProductPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPriceQuery, GetProductPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPriceQuery, GetProductPriceQueryVariables>(GetProductPriceDocument, options);
        }
export function useGetProductPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductPriceQuery, GetProductPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPriceQuery, GetProductPriceQueryVariables>(GetProductPriceDocument, options);
        }
export type GetProductPriceQueryHookResult = ReturnType<typeof useGetProductPriceQuery>;
export type GetProductPriceLazyQueryHookResult = ReturnType<typeof useGetProductPriceLazyQuery>;
export type GetProductPriceSuspenseQueryHookResult = ReturnType<typeof useGetProductPriceSuspenseQuery>;
export type GetProductPriceQueryResult = Apollo.QueryResult<GetProductPriceQuery, GetProductPriceQueryVariables>;
export const GetProductReviewsDocument = gql`
    query getProductReviews($id: ID!, $offset: Int!, $limit: Int!) {
  product(input: {id: $id}) {
    ...ProductFields
    reviews(offset: $offset, limit: $limit) {
      totalRecords
      records {
        ...ReviewFields
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${ReviewFieldsFragmentDoc}`;

/**
 * __useGetProductReviewsQuery__
 *
 * To run a query within a React component, call `useGetProductReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProductReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetProductReviewsQuery, GetProductReviewsQueryVariables> & ({ variables: GetProductReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductReviewsQuery, GetProductReviewsQueryVariables>(GetProductReviewsDocument, options);
      }
export function useGetProductReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductReviewsQuery, GetProductReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductReviewsQuery, GetProductReviewsQueryVariables>(GetProductReviewsDocument, options);
        }
export function useGetProductReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductReviewsQuery, GetProductReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductReviewsQuery, GetProductReviewsQueryVariables>(GetProductReviewsDocument, options);
        }
export type GetProductReviewsQueryHookResult = ReturnType<typeof useGetProductReviewsQuery>;
export type GetProductReviewsLazyQueryHookResult = ReturnType<typeof useGetProductReviewsLazyQuery>;
export type GetProductReviewsSuspenseQueryHookResult = ReturnType<typeof useGetProductReviewsSuspenseQuery>;
export type GetProductReviewsQueryResult = Apollo.QueryResult<GetProductReviewsQuery, GetProductReviewsQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($productIds: [ID!], $locationId: ID, $currency: Currency, $fromDate: Date!, $untilDate: Date!, $groupSize: Int, $lang: Iso639!, $tagIds: [ID!], $timeRanges: [TimeRangeEnum!]) {
  products(input: {ids: $productIds, locationId: $locationId, tagIds: $tagIds}) {
    records {
      ...ProductFields
      prices(currency: $currency) {
        ...ProductPriceFields
      }
      translation(lang: $lang) {
        ...ProductTranslationFields
      }
      media {
        ...ProductMediaFields
      }
      reviewSummary {
        average
        numReviews
      }
      tags {
        ...TagFields
        translation(lang: $lang) {
          ...TagTranslationFields
        }
      }
      mainPrice(currency: $currency) {
        amount
        currency
      }
      privatePrices(currency: $currency) {
        ...ProductPrivatePriceFields
      }
      availability(
        fromDate: $fromDate
        untilDate: $untilDate
        groupSize: $groupSize
        timeRanges: $timeRanges
      ) {
        date
        status
        timeSlots {
          time
          status
        }
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}
${ProductTranslationFieldsFragmentDoc}
${ProductMediaFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${TagTranslationFieldsFragmentDoc}
${ProductPrivatePriceFieldsFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      locationId: // value for 'locationId'
 *      currency: // value for 'currency'
 *      fromDate: // value for 'fromDate'
 *      untilDate: // value for 'untilDate'
 *      groupSize: // value for 'groupSize'
 *      lang: // value for 'lang'
 *      tagIds: // value for 'tagIds'
 *      timeRanges: // value for 'timeRanges'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables> & ({ variables: GetProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetSearchProductsDocument = gql`
    query getSearchProducts($fromDate: Date!, $groupSize: Int!, $lang: Iso639!, $locationId: ID, $tagIds: [ID!], $timeRanges: [TimeRangeEnum!], $untilDate: Date!, $currency: Currency) {
  searchProducts(
    input: {fromDate: $fromDate, groupSize: $groupSize, lang: $lang, locationId: $locationId, tagIds: $tagIds, timeRanges: $timeRanges, untilDate: $untilDate}
  ) {
    records {
      id
      earliestAvailability
      poster
      duration
      displayPrice(currency: $currency) {
        ...ProductDisplayPriceFields
      }
      reviewSummary {
        numReviews
        average
      }
      tags {
        id
        translation(lang: $lang) {
          name
        }
      }
      translation(lang: $lang) {
        name
        headline
      }
    }
  }
}
    ${ProductDisplayPriceFieldsFragmentDoc}`;

/**
 * __useGetSearchProductsQuery__
 *
 * To run a query within a React component, call `useGetSearchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchProductsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      groupSize: // value for 'groupSize'
 *      lang: // value for 'lang'
 *      locationId: // value for 'locationId'
 *      tagIds: // value for 'tagIds'
 *      timeRanges: // value for 'timeRanges'
 *      untilDate: // value for 'untilDate'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetSearchProductsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchProductsQuery, GetSearchProductsQueryVariables> & ({ variables: GetSearchProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchProductsQuery, GetSearchProductsQueryVariables>(GetSearchProductsDocument, options);
      }
export function useGetSearchProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchProductsQuery, GetSearchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchProductsQuery, GetSearchProductsQueryVariables>(GetSearchProductsDocument, options);
        }
export function useGetSearchProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchProductsQuery, GetSearchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchProductsQuery, GetSearchProductsQueryVariables>(GetSearchProductsDocument, options);
        }
export type GetSearchProductsQueryHookResult = ReturnType<typeof useGetSearchProductsQuery>;
export type GetSearchProductsLazyQueryHookResult = ReturnType<typeof useGetSearchProductsLazyQuery>;
export type GetSearchProductsSuspenseQueryHookResult = ReturnType<typeof useGetSearchProductsSuspenseQuery>;
export type GetSearchProductsQueryResult = Apollo.QueryResult<GetSearchProductsQuery, GetSearchProductsQueryVariables>;
export const GetTagOptionsDocument = gql`
    query getTagOptions {
  tags(hasProducts: true) {
    records {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTagOptionsQuery__
 *
 * To run a query within a React component, call `useGetTagOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagOptionsQuery, GetTagOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagOptionsQuery, GetTagOptionsQueryVariables>(GetTagOptionsDocument, options);
      }
export function useGetTagOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagOptionsQuery, GetTagOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagOptionsQuery, GetTagOptionsQueryVariables>(GetTagOptionsDocument, options);
        }
export function useGetTagOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagOptionsQuery, GetTagOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagOptionsQuery, GetTagOptionsQueryVariables>(GetTagOptionsDocument, options);
        }
export type GetTagOptionsQueryHookResult = ReturnType<typeof useGetTagOptionsQuery>;
export type GetTagOptionsLazyQueryHookResult = ReturnType<typeof useGetTagOptionsLazyQuery>;
export type GetTagOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTagOptionsSuspenseQuery>;
export type GetTagOptionsQueryResult = Apollo.QueryResult<GetTagOptionsQuery, GetTagOptionsQueryVariables>;
export const GetWaitingListUserDocument = gql`
    query getWaitingListUser($accessKey: ID!) {
  waitingListUser(accessKey: $accessKey) {
    id
    email
    phoneNumber
    timeZone
    waitingLists {
      id
      productId
      fromDate
      untilDate
      groupSize
      active
    }
  }
}
    `;

/**
 * __useGetWaitingListUserQuery__
 *
 * To run a query within a React component, call `useGetWaitingListUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingListUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingListUserQuery({
 *   variables: {
 *      accessKey: // value for 'accessKey'
 *   },
 * });
 */
export function useGetWaitingListUserQuery(baseOptions: Apollo.QueryHookOptions<GetWaitingListUserQuery, GetWaitingListUserQueryVariables> & ({ variables: GetWaitingListUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>(GetWaitingListUserDocument, options);
      }
export function useGetWaitingListUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>(GetWaitingListUserDocument, options);
        }
export function useGetWaitingListUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>(GetWaitingListUserDocument, options);
        }
export type GetWaitingListUserQueryHookResult = ReturnType<typeof useGetWaitingListUserQuery>;
export type GetWaitingListUserLazyQueryHookResult = ReturnType<typeof useGetWaitingListUserLazyQuery>;
export type GetWaitingListUserSuspenseQueryHookResult = ReturnType<typeof useGetWaitingListUserSuspenseQuery>;
export type GetWaitingListUserQueryResult = Apollo.QueryResult<GetWaitingListUserQuery, GetWaitingListUserQueryVariables>;
export const GetYoutuberProductDocument = gql`
    query getYoutuberProduct($id: ID!, $language: Iso639!, $currency: Currency!) {
  product(input: {id: $id}) {
    id
    translation(lang: $language) {
      name
    }
    displayPrice(currency: $currency) {
      amount
      currency
    }
    reviewSummary {
      average
      numReviews
    }
  }
}
    `;

/**
 * __useGetYoutuberProductQuery__
 *
 * To run a query within a React component, call `useGetYoutuberProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYoutuberProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYoutuberProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetYoutuberProductQuery(baseOptions: Apollo.QueryHookOptions<GetYoutuberProductQuery, GetYoutuberProductQueryVariables> & ({ variables: GetYoutuberProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYoutuberProductQuery, GetYoutuberProductQueryVariables>(GetYoutuberProductDocument, options);
      }
export function useGetYoutuberProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYoutuberProductQuery, GetYoutuberProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYoutuberProductQuery, GetYoutuberProductQueryVariables>(GetYoutuberProductDocument, options);
        }
export function useGetYoutuberProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetYoutuberProductQuery, GetYoutuberProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYoutuberProductQuery, GetYoutuberProductQueryVariables>(GetYoutuberProductDocument, options);
        }
export type GetYoutuberProductQueryHookResult = ReturnType<typeof useGetYoutuberProductQuery>;
export type GetYoutuberProductLazyQueryHookResult = ReturnType<typeof useGetYoutuberProductLazyQuery>;
export type GetYoutuberProductSuspenseQueryHookResult = ReturnType<typeof useGetYoutuberProductSuspenseQuery>;
export type GetYoutuberProductQueryResult = Apollo.QueryResult<GetYoutuberProductQuery, GetYoutuberProductQueryVariables>;
export const GuideTabDataDocument = gql`
    query GuideTabData($bookingId: ID!) {
  booking(id: $bookingId) {
    group {
      date
      time
      hasEnded
      product {
        duration
        location {
          timezone
        }
        meetingPlaceGoogleMapsQuery {
          placeId
          geoLocation {
            lat
            lng
          }
        }
      }
      guideAssignments {
        role
        lastKnownLocation {
          dateTime
          lat
          lng
        }
        guide {
          id
          nickName
          profilePic
          languages {
            name
          }
          metrics {
            numTours
            numPeople
          }
          reviewSummary {
            average
            numReviews
          }
          translation(lang: en) {
            description
            hobbies
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGuideTabDataQuery__
 *
 * To run a query within a React component, call `useGuideTabDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuideTabDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuideTabDataQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGuideTabDataQuery(baseOptions: Apollo.QueryHookOptions<GuideTabDataQuery, GuideTabDataQueryVariables> & ({ variables: GuideTabDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuideTabDataQuery, GuideTabDataQueryVariables>(GuideTabDataDocument, options);
      }
export function useGuideTabDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuideTabDataQuery, GuideTabDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuideTabDataQuery, GuideTabDataQueryVariables>(GuideTabDataDocument, options);
        }
export function useGuideTabDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GuideTabDataQuery, GuideTabDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuideTabDataQuery, GuideTabDataQueryVariables>(GuideTabDataDocument, options);
        }
export type GuideTabDataQueryHookResult = ReturnType<typeof useGuideTabDataQuery>;
export type GuideTabDataLazyQueryHookResult = ReturnType<typeof useGuideTabDataLazyQuery>;
export type GuideTabDataSuspenseQueryHookResult = ReturnType<typeof useGuideTabDataSuspenseQuery>;
export type GuideTabDataQueryResult = Apollo.QueryResult<GuideTabDataQuery, GuideTabDataQueryVariables>;